var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return n(r, t, e, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, i) {
        return 6 === n.a ? n.f(r, t, e, u, a, i) : n(r)(t)(e)(u)(a)(i);
    }
    function A7(n, r, t, e, u, a, i, o) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, o) : n(r)(t)(e)(u)(a)(i)(o);
    }
    function t(n, r) {
        for(var t, u = [], a = e(n, r, 0, u); a && (t = u.pop()); a = e(t.a, t.b, 0, u));
        return a;
    }
    function e(n, r, t, u) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && h(5), !1;
        if (t > 100) return u.push(i(n, r)), !0;
        for(var a in 0 > n.$ && (n = vr(n), r = vr(r)), n)if (!e(n[a], r[a], t + 1, u)) return !1;
        return !0;
    }
    function u(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = u(n.a, r.a)) || (t = u(n.b, r.b)) ? t : u(n.c, r.c);
        for(; n.b && r.b && !(t = u(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var a = F2(function(n, r) {
        var t = u(n, r);
        return 0 > t ? fr : t ? cr : or;
    });
    function i(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function o(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function c(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = s(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = s(n.a, r);
        return t;
    }
    var f = {
        $: 0
    };
    function s(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var b = F2(s);
    function v(n) {
        for(var r = f, t = n.length; t--;)r = s(n[t], r);
        return r;
    }
    var l = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return v(e);
    }), d = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), $ = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, i(t, r);
    });
    function h(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var g = F2(function(n, r) {
        return n + r;
    }), p = Math.ceil, m = Math.floor, y = Math.log, w = F2(function(n, r) {
        return r.split(n);
    }), A = F2(function(n, r) {
        return r.join(n);
    }), k = F3(function(n, r, t) {
        return t.slice(n, r);
    }), x = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(e)) return !1;
        }
        return !0;
    }), E = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), j = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), L = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return f;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return v(u);
    });
    function C(n) {
        return {
            $: 2,
            b: n
        };
    }
    var N = C(function(n) {
        return "number" != typeof n ? Q("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? gr(n) : !isFinite(n) || n % 1 ? Q("an INT", n) : gr(n);
    }), M = (C(function(n) {
        return "boolean" == typeof n ? gr(n) : Q("a BOOL", n);
    }), C(function(n) {
        return "number" == typeof n ? gr(n) : Q("a FLOAT", n);
    }), C(function(n) {
        return gr(n);
    })), _ = C(function(n) {
        return "string" == typeof n ? gr(n) : n instanceof String ? gr(n + "") : Q("a STRING", n);
    }), q = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function I(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var T = F2(function(n, r) {
        return I(n, [
            r
        ]);
    }), R = F3(function(n, r, t) {
        return I(n, [
            r,
            t
        ]);
    }), O = F4(function(n, r, t, e) {
        return I(n, [
            r,
            t,
            e
        ]);
    }), z = F5(function(n, r, t, e, u) {
        return I(n, [
            r,
            t,
            e,
            u
        ]);
    }), D = F2(function(n, r) {
        try {
            return G(n, JSON.parse(r));
        } catch (n) {
            return lr(A2(dr, "This is not valid JSON! " + n.message, r));
        }
    }), F = F2(function(n, r) {
        return G(n, r);
    });
    function G(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? gr(n.c) : Q("null", r);
            case 3:
                return J(r) ? S(n.b, r, v) : Q("a LIST", r);
            case 4:
                return J(r) ? S(n.b, r, B) : Q("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return Q("an OBJECT with a field named `" + t + "`", r);
                var e = G(n.b, r[t]);
                return it(e) ? e : lr(A2($r, t, e.a));
            case 7:
                var u = n.e;
                return J(r) ? r.length > u ? (e = G(n.b, r[u]), it(e) ? e : lr(A2(hr, u, e.a))) : Q("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : Q("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || J(r)) return Q("an OBJECT", r);
                var a = f;
                for(var o in r)if (r.hasOwnProperty(o)) {
                    if (e = G(n.b, r[o]), !it(e)) return lr(A2($r, o, e.a));
                    a = s(i(o, e.a), a);
                }
                return gr(Dr(a));
            case 9:
                for(var c = n.f, b = n.g, l = 0; b.length > l; l++){
                    if (e = G(b[l], r), !it(e)) return e;
                    c = c(e.a);
                }
                return gr(c);
            case 10:
                return e = G(n.b, r), it(e) ? G(n.h(e.a), r) : e;
            case 11:
                for(var d = f, $ = n.g; $.b; $ = $.b){
                    if (e = G($.a, r), it(e)) return e;
                    d = s(e.a, d);
                }
                return lr(pr(Dr(d)));
            case 1:
                return lr(A2(dr, n.a, r));
            case 0:
                return gr(n.a);
        }
    }
    function S(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = G(n, r[a]);
            if (!it(i)) return lr(A2(hr, a, i.a));
            u[a] = i.a;
        }
        return gr(t(u));
    }
    function J(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function B(n) {
        return A2(at, n.length, function(r) {
            return n[r];
        });
    }
    function Q(n, r) {
        return lr(A2(dr, "Expecting " + n, r));
    }
    function H(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return H(n.b, r.b);
            case 6:
                return n.d === r.d && H(n.b, r.b);
            case 7:
                return n.e === r.e && H(n.b, r.b);
            case 9:
                return n.f === r.f && P(n.g, r.g);
            case 10:
                return n.h === r.h && H(n.b, r.b);
            case 11:
                return P(n.g, r.g);
        }
    }
    function P(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!H(n[e], r[e])) return !1;
        return !0;
    }
    var W = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function K(n) {
        return n;
    }
    function Z(n) {
        return {
            $: 0,
            a: n
        };
    }
    function U(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var Y = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), V = 0;
    function X(n) {
        var r = {
            $: 0,
            e: V++,
            f: n,
            g: null,
            h: []
        };
        return tn(r), r;
    }
    var nn = !1, rn = [];
    function tn(n) {
        if (rn.push(n), !nn) {
            for(nn = !0; n = rn.shift();)en(n);
            nn = !1;
        }
    }
    function en(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, tn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var un = {};
    function an(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function on(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function o(n) {
            return A2(Y, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, t, o, n) : a && i ? A4(e, t, o.i, o.j, n) : A3(e, t, a ? o.i : o.j, n);
                }
            });
        }
        return t.h = X(A2(Y, o, n.b));
    }
    var cn = F2(function(n, r) {
        return U(function(t) {
            n.g(r), t(Z(0));
        });
    });
    function fn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function sn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var bn, vn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), ln = [], dn = !1;
    function $n(n, r, t) {
        if (ln.push({
            p: n,
            q: r,
            r: t
        }), !dn) {
            dn = !0;
            for(var e; e = ln.shift();)hn(e.p, e.q, e.r);
            dn = !1;
        }
    }
    function hn(n, r, t) {
        var e, u = {};
        for(var a in gn(!0, r, u, null), gn(!1, t, u, null), n)(e = n[a]).h.push({
            $: "fx",
            a: u[a] || {
                i: f,
                j: f
            }
        }), tn(e);
    }
    function gn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? un[r].e : un[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: f,
                        j: f
                    }, n ? t.i = s(r, t.i) : t.j = s(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)gn(n, i.a, t, e);
                return;
            case 3:
                return void gn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    var pn = "undefined" != typeof document ? document : {};
    function mn(n, r) {
        n.appendChild(r);
    }
    function yn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var wn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Mn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Mn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var An, kn = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), xn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), En = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), jn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), Ln = /^(on|formAction$)/i, Cn = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, Nn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function Mn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? _n(i, u, a) : i[u] = a;
            } else "className" === u ? _n(r, u, a) : r[u] = a;
        }
        return r;
    }
    function _n(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function qn(n, r) {
        var t = n.$;
        if (5 === t) return qn(n.k || (n.k = n.m()), r);
        if (0 === t) return pn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = qn(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return In(i = n.h(n.g), r, n.d), i;
        var i = n.f ? pn.createElementNS(n.f, n.c) : pn.createElement(n.c);
        bn && "a" == n.c && i.addEventListener("click", bn(i)), In(i, r, n.d);
        for(var o = n.e, c = 0; o.length > c; c++)mn(i, qn(1 === t ? o[c] : o[c].b, r));
        return i;
    }
    function In(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Tn(n, u) : "a0" === e ? zn(n, r, u) : "a3" === e ? Rn(n, u) : "a4" === e ? On(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Tn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Rn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function On(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function zn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = Dn(r, a), n.addEventListener(u, i, An && {
                    passive: 2 > st(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                An = !0;
            }
        }));
    } catch (n) {}
    function Dn(n, r) {
        function t(r) {
            var e = t.q, u = G(e.a, r);
            if (it(u)) {
                for(var a, i = st(e), o = u.a, c = i ? 3 > i ? o.a : o.v : o, f = 1 == i ? o.b : 3 == i && o.aD, s = (f && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.ay) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var b = a.length; b--;)c = a[b](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return t.q = r, t;
    }
    function Fn(n, r) {
        return n.$ == r.$ && H(n.a, r.a);
    }
    function Gn(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Sn(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void Gn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, o = r.l, c = i.length, f = c === o.length; f && c--;)f = i[c] === o[c];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Sn(n.k, r.k, s, 0), void (s.length > 0 && Gn(t, 1, e, s));
                case 4:
                    for(var b = n.j, v = r.j, l = !1, d = n.k; 4 === d.$;)l = !0, "object" != typeof b ? b = [
                        b,
                        d.j
                    ] : b.push(d.j), d = d.k;
                    for(var $ = r.k; 4 === $.$;)l = !0, "object" != typeof v ? v = [
                        v,
                        $.j
                    ] : v.push($.j), $ = $.k;
                    return l && b.length !== v.length ? void Gn(t, 0, e, r) : ((l ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(b, v) : b === v) || Gn(t, 2, e, v), void Sn(d, $, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Gn(t, 3, e, r.a));
                case 1:
                    return void Jn(n, r, t, e, Qn);
                case 2:
                    return void Jn(n, r, t, e, Hn);
                case 3:
                    if (n.h !== r.h) return void Gn(t, 0, e, r);
                    var h = Bn(n.d, r.d);
                    h && Gn(t, 4, e, h);
                    var g = r.i(n.g, r.g);
                    return void (g && Gn(t, 5, e, g));
            }
        }
    }
    function Jn(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = Bn(n.d, r.d);
            a && Gn(t, 4, e, a), u(n, r, t, e);
        } else Gn(t, 0, e, r);
    }
    function Bn(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && Fn(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = Bn(n[u], r[u] || {}, u);
            o && ((e = e || {})[u] = o);
        }
        for(var c in r)c in n || ((e = e || {})[c] = r[c]);
        return e;
    }
    function Qn(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, o = a.length;
        i > o ? Gn(t, 6, e, {
            v: o,
            i: i - o
        }) : o > i && Gn(t, 7, e, {
            v: i,
            e: a
        });
        for(var c = o > i ? i : o, f = 0; c > f; f++){
            var s = u[f];
            Sn(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function Hn(n, r, t, e) {
        for(var u = [], a = {}, i = [], o = n.e, c = r.e, f = o.length, s = c.length, b = 0, v = 0, l = e; f > b && s > v;){
            var d = (j = o[b]).a, $ = (L = c[v]).a, h = j.b, g = L.b, p = void 0, m = void 0;
            if (d !== $) {
                var y = o[b + 1], w = c[v + 1];
                if (y) {
                    var A = y.a, k = y.b;
                    m = $ === A;
                }
                if (w) {
                    var x = w.a, E = w.b;
                    p = d === x;
                }
                if (p && m) Sn(h, E, u, ++l), Wn(a, u, d, g, v, i), l += h.b || 0, Kn(a, u, d, k, ++l), l += k.b || 0, b += 2, v += 2;
                else if (p) l++, Wn(a, u, $, g, v, i), Sn(h, E, u, l), l += h.b || 0, b += 1, v += 2;
                else if (m) Kn(a, u, d, h, ++l), l += h.b || 0, Sn(k, g, u, ++l), l += k.b || 0, b += 2, v += 1;
                else {
                    if (!y || A !== x) break;
                    Kn(a, u, d, h, ++l), Wn(a, u, $, g, v, i), l += h.b || 0, Sn(k, E, u, ++l), l += k.b || 0, b += 2, v += 2;
                }
            } else Sn(h, g, u, ++l), l += h.b || 0, b++, v++;
        }
        for(; f > b;){
            var j;
            l++, Kn(a, u, (j = o[b]).a, h = j.b, l), l += h.b || 0, b++;
        }
        for(; s > v;){
            var L, C = C || [];
            Wn(a, u, (L = c[v]).a, L.b, void 0, C), v++;
        }
        (u.length > 0 || i.length > 0 || C) && Gn(t, 8, e, {
            w: u,
            x: i,
            y: C
        });
    }
    var Pn = "_elmW6BL";
    function Wn(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return Sn(i.z, e, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        Wn(n, r, t + Pn, e, u, a);
    }
    function Kn(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return Sn(e, a.z, i, u), void Gn(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            Kn(n, r, t + Pn, e, u);
        } else {
            var o = Gn(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: o
            };
        }
    }
    function Zn(n, r, t, e) {
        Un(n, r, t, 0, 0, r.b, e);
    }
    function Un(n, r, t, e, u, a, i) {
        for(var o = t[e], c = o.r; c === u;){
            var f = o.$;
            if (1 === f) Zn(n, r.k, o.s, i);
            else if (8 === f) o.t = n, o.u = i, (s = o.s.w).length > 0 && Un(n, r, s, 0, u, a, i);
            else if (9 === f) {
                o.t = n, o.u = i;
                var s, b = o.s;
                b && (b.A.s = n, (s = b.w).length > 0 && Un(n, r, s, 0, u, a, i));
            } else o.t = n, o.u = i;
            if (!(o = t[++e]) || (c = o.r) > a) return e;
        }
        var v = r.$;
        if (4 === v) {
            for(var l = r.k; 4 === l.$;)l = l.k;
            return Un(n, l, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var d = r.e, $ = n.childNodes, h = 0; d.length > h; h++){
            u++;
            var g = 1 === v ? d[h] : d[h].b, p = u + (g.b || 0);
            if (!(u > c || c > p || (o = t[e = Un($[h], g, t, e, u, p, i)]) && (c = o.r) <= a)) return e;
            u = p;
        }
        return e;
    }
    function Yn(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = Vn(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function Vn(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = qn(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return In(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Yn(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, a = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(qn(u[e], r.u), a);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var i = t.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = Yn(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = pn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                mn(t, 2 === u.c ? u.s : qn(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Yn(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, c = 2 === o.c ? o.s : qn(o.z, r.u);
                        n.insertBefore(c, n.childNodes[i.r]);
                    }
                    return e && mn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                h(10);
        }
    }
    function Xn(n) {
        if (3 === n.nodeType) return yn(n.textContent);
        if (1 !== n.nodeType) return yn("");
        for(var r = f, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = s(A2(jn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = f, o = n.childNodes;
        for(e = o.length; e--;)i = s(Xn(o[e]), i);
        return A3(wn, a, r, i);
    }
    var nr = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, a) {
            var i = A2(F, n, r ? r.flags : void 0);
            it(i) || h(2);
            var o = {}, c = t(i.a), f = c.a, s = a(v, f), b = function(n, r) {
                var t;
                for(var e in un){
                    var u = un[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = on(u, r);
                }
                return t;
            }(o, v);
            function v(n, r) {
                var t = A2(e, n, f);
                s(f = t.a, r), $n(o, t.b, u(f));
            }
            return $n(o, c.b, u(f)), b ? {
                ports: b
            } : {};
        }(r, e, n.bo, n.bI, n.bD, function(r, t) {
            var e = n.aB && n.aB(r), u = n.bJ, a = pn.title, i = pn.body, o = Xn(i);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (rr(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && rr(e), t = 2);
                };
            }(t, function(n) {
                bn = e;
                var t = u(n), c = wn("body")(f)(t.aI), s = function(n, r) {
                    var t = [];
                    return Sn(n, r, t, 0), t;
                }(o, c);
                i = function(n, r, t, e) {
                    return 0 === t.length ? n : (Zn(n, r, t, e), Yn(n, t));
                }(i, o, s, r), o = c, bn = 0, a !== t.a7 && (pn.title = a = t.a7);
            });
        });
    }), rr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function tr() {
        return Et(pn.location.href).a || h(1);
    }
    var er = F2(function(n, r) {
        return A2(Bt, jt, U(function() {
            history.pushState({}, "", r), n();
        }));
    }), ur = ("undefined" != typeof document && document, "undefined" != typeof window ? window : {
        addEventListener: function() {},
        removeEventListener: function() {}
    }), ar = F2(function(n, r) {
        var t = "g";
        n.br && (t += "m"), n.bf && (t += "i");
        try {
            return yr(RegExp(r, t));
        } catch (n) {
            return wr;
        }
    }), ir = F3(function(n, r, t) {
        for(var e, u = [], a = 0, i = t, o = r.lastIndex, c = -1; a++ < n && (e = r.exec(i)) && c != r.lastIndex;){
            for(var f = e.length - 1, s = Array(f); f > 0;){
                var b = e[f];
                s[--f] = b ? yr(b) : wr;
            }
            u.push(A4(Ba, e[0], e.index, a, v(s))), c = r.lastIndex;
        }
        return r.lastIndex = o, v(u);
    }), or = 1, cr = 2, fr = 0, sr = b, br = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(br, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), vr = function(n) {
        return A3(br, F3(function(n, r, t) {
            return A2(sr, i(n, r), t);
        }), f, n);
    }, lr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), $r = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), hr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), gr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mr = g, yr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wr = {
        $: 1
    }, Ar = x, kr = W, xr = function(n) {
        return n + "";
    }, Er = F2(function(n, r) {
        return A2(A, n, function(n) {
            for(var r = []; n.b; n = n.b)r.push(n.a);
            return r;
        }(r));
    }), jr = F2(function(n, r) {
        return v(A2(w, n, r));
    }), Lr = function(n) {
        return A2(Er, "\n    ", A2(jr, "\n", n));
    }, Cr = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), Nr = function(n) {
        return A3(Cr, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Mr = l, _r = F3(function(n, r, t) {
        for(;;){
            if (u(n, r) >= 1) return t;
            var e = n, a = r - 1, i = A2(sr, r, t);
            n = e, r = a, t = i;
        }
    }), qr = F2(function(n, r) {
        return A3(_r, n, r, f);
    }), Ir = F2(function(n, r) {
        return A3(Mr, n, A2(qr, 0, Nr(r) - 1), r);
    }), Tr = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Rr = function(n) {
        var r = Tr(n);
        return r >= 97 && 122 >= r;
    }, Or = function(n) {
        var r = Tr(n);
        return 90 >= r && r >= 65;
    }, zr = function(n) {
        return Rr(n) || Or(n) || function(n) {
            var r = Tr(n);
            return 57 >= r && r >= 48;
        }(n);
    }, Dr = function(n) {
        return A3(Cr, sr, f, n);
    }, Fr = F2(function(n, r) {
        return "\n\n(" + xr(n + 1) + ") " + Lr(Gr(r));
    }), Gr = function(n) {
        return A2(Sr, n, f);
    }, Sr = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n, r, e = (r = (n = t).charCodeAt(0), isNaN(r) ? wr : yr(55296 > r || r > 56319 ? i(n[0], n.slice(1)) : i(n[0] + n[1], n.slice(2))));
                    if (1 === e.$) return !1;
                    var u, a = e.a, o = a.b;
                    return (Rr(u = a.a) || Or(u)) && A2(Ar, zr, o);
                }();
                n = e, r = A2(sr, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var a = "[" + xr(n.a) + "]";
                n = e, r = A2(sr, a, r);
                continue n;
            case 2:
                var o = n.a;
                if (o.b) {
                    if (o.b.b) {
                        var c = (r.b ? "The Json.Decode.oneOf at json" + A2(Er, "", Dr(r)) : "Json.Decode.oneOf") + " failed in the following " + xr(Nr(o)) + " ways:";
                        return A2(Er, "\n\n", A2(sr, c, A2(Ir, Fr, o)));
                    }
                    n = e = o.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(Er, "", Dr(r)) : "!");
            default:
                var f = n.a, s = n.b;
                return (c = r.b ? "Problem with the value at json" + A2(Er, "", Dr(r)) + ":\n\n    " : "Problem with the given value:\n\n") + Lr(A2(kr, 4, s)) + "\n\n" + f;
        }
    }), Jr = 32, Br = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Qr = [], Hr = p, Pr = F2(function(n, r) {
        return y(r) / y(n);
    }), Wr = Hr(A2(Pr, 2, Jr)), Kr = A4(Br, 0, Wr, Qr, Qr), Zr = d, Ur = F2(function(n, r) {
        return r(n);
    }), Yr = m, Vr = function(n) {
        return n.length;
    }, Xr = F2(function(n, r) {
        return u(n, r) > 0 ? n : r;
    }), nt = $, rt = F2(function(n, r) {
        for(;;){
            var t = A2(nt, Jr, n), e = t.b, u = A2(sr, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return Dr(u);
            n = e, r = u;
        }
    }), tt = F2(function(n, r) {
        for(;;){
            var t = Hr(r / Jr);
            if (1 === t) return A2(nt, Jr, n).a;
            n = A2(rt, n, f), r = t;
        }
    }), et = F2(function(n, r) {
        if (r.c) {
            var t = r.c * Jr, e = Yr(A2(Pr, Jr, t - 1)), u = n ? Dr(r.f) : r.f, a = A2(tt, u, r.c);
            return A4(Br, Vr(r.e) + t, A2(Xr, 5, e * Wr), a, r.e);
        }
        return A4(Br, Vr(r.e), Wr, Qr, r.e);
    }), ut = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(et, !1, {
                f: e,
                c: t / Jr | 0,
                e: u
            });
            var a = {
                $: 1,
                a: A3(Zr, Jr, r, n)
            };
            r -= Jr, e = A2(sr, a, e);
        }
    }), at = F2(function(n, r) {
        if (n > 0) {
            var t = n % Jr;
            return A5(ut, r, n - t - Jr, n, f, A3(Zr, t, n - t, r));
        }
        return Kr;
    }), it = function(n) {
        return !n.$;
    }, ot = T, ct = R, ft = function(n) {
        return {
            $: 0,
            a: n
        };
    }, st = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, bt = function(n) {
        return n;
    }, vt = F6(function(n, r, t, e, u, a) {
        return {
            aN: a,
            aP: r,
            aT: e,
            aW: t,
            aZ: n,
            a_: u
        };
    }), lt = E, dt = k, $t = F2(function(n, r) {
        return 1 > n ? r : A3(dt, n, r.length, r);
    }), ht = L, gt = function(n) {
        return "" === n;
    }, pt = F2(function(n, r) {
        return 1 > n ? "" : A3(dt, 0, n, r);
    }), mt = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return wr;
            r = 10 * r + a - 48;
        }
        return u == e ? wr : yr(45 == t ? -r : r);
    }, yt = F5(function(n, r, t, e, u) {
        if (gt(u) || A2(lt, "@", u)) return wr;
        var a = A2(ht, ":", u);
        if (a.b) {
            if (a.b.b) return wr;
            var i = a.a, o = mt(A2($t, i + 1, u));
            if (1 === o.$) return wr;
            var c = o;
            return yr(A6(vt, n, A2(pt, i, u), c, r, t, e));
        }
        return yr(A6(vt, n, u, wr, r, t, e));
    }), wt = F4(function(n, r, t, e) {
        if (gt(e)) return wr;
        var u = A2(ht, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(yt, n, A2($t, a, e), r, t, A2(pt, a, e));
        }
        return A5(yt, n, "/", r, t, e);
    }), At = F3(function(n, r, t) {
        if (gt(t)) return wr;
        var e = A2(ht, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(wt, n, yr(A2($t, u + 1, t)), r, A2(pt, u, t));
        }
        return A4(wt, n, wr, r, t);
    }), kt = F2(function(n, r) {
        if (gt(r)) return wr;
        var t = A2(ht, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(At, n, yr(A2($t, e + 1, r)), A2(pt, e, r));
        }
        return A3(At, n, wr, r);
    }), xt = j, Et = function(n) {
        return A2(xt, "http://", n) ? A2(kt, 0, A2($t, 7, n)) : A2(xt, "https://", n) ? A2(kt, 1, A2($t, 8, n)) : wr;
    }, jt = function() {
        for(;;);
    }, Lt = Z, Ct = Lt(0), Nt = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var c = o.a, f = o.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, c, A2(n, f.a, t > 500 ? A3(Cr, n, r, Dr(s)) : A4(Nt, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, c, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Mt = F3(function(n, r, t) {
        return A4(Nt, n, r, 0, t);
    }), _t = F2(function(n, r) {
        return A3(Mt, F2(function(r, t) {
            return A2(sr, n(r), t);
        }), f, r);
    }), qt = Y, It = F2(function(n, r) {
        return A2(qt, function(r) {
            return Lt(n(r));
        }, r);
    }), Tt = F3(function(n, r, t) {
        return A2(qt, function(r) {
            return A2(qt, function(t) {
                return Lt(A2(n, r, t));
            }, t);
        }, r);
    }), Rt = cn, Ot = F2(function(n, r) {
        var t = r;
        return function(n) {
            return U(function(r) {
                r(Z(X(n)));
            });
        }(A2(qt, Rt(n), t));
    }), zt = F3(function(n, r) {
        var t;
        return A2(It, function() {
            return 0;
        }, (t = A2(_t, Ot(n), r), A3(Mt, Tt(sr), Lt(f), t)));
    }), Dt = F3(function() {
        return Lt(0);
    }), Ft = F2(function(n, r) {
        return A2(It, n, r);
    });
    un.Task = an(Ct, zt, Dt, Ft);
    var Gt, St, Jt = fn("Task"), Bt = F2(function(n, r) {
        return Jt(A2(It, n, r));
    }), Qt = {
        $: 0
    }, Ht = F, Pt = {
        aQ: f,
        az: f,
        a$: f,
        a9: f,
        aF: f,
        bc: f
    }, Wt = function(n) {
        return {
            J: n
        };
    }, Kt = F6(function(n, r, t, e, u, a) {
        return {
            aQ: n,
            az: e,
            a$: u,
            a9: r,
            aF: a,
            bc: t
        };
    }), Zt = F3(function(n, r, t) {
        return n(r(t));
    }), Ut = q, Yt = _, Vt = A2(ot, function(n) {
        return {
            bj: n
        };
    }, A2(Ut, "event", Yt)), Xt = A5(z, F4(function(n, r, t, e) {
        return {
            bE: n,
            bF: r,
            bG: t,
            bH: e
        };
    }), A2(Ut, "term1", Yt), A2(Ut, "term2", Yt), A2(Ut, "term3", Yt), A2(Ut, "term4", Yt)), ne = function(n) {
        return {
            $: 3,
            b: n
        };
    }, re = A3(ct, F2(function(n, r) {
        return {
            bA: n,
            az: r
        };
    }), A2(Ut, "problem", Yt), A2(Ut, "quest", Yt)), te = ct(Ur), ee = F3(function(n, r, t) {
        return A2(te, A2(Ut, n, r), t);
    }), ue = F3(function(n, r, t) {
        return {
            aL: r,
            aM: t,
            a3: n
        };
    }), ae = N, ie = O, oe = function(n) {
        return A4(ie, ue, A2(Ut, "start", ae), A2(Ut, "end", ae), A2(Ut, "entry", n));
    }, ce = A2(ot, function(n) {
        return {
            aF: n
        };
    }, A2(Ut, "verb", Yt)), fe = A3(ee, "verb", (Gt = A2(Zt, ne, oe))(ce), A3(ee, "questSource", Gt(Yt), A3(ee, "quest", Gt(re), A3(ee, "wildernessEvent", Gt(Vt), A3(ee, "urbanEvent", Gt(Vt), A3(ee, "itemRelicName", Gt(Xt), ft(Kt))))))), se = A2(ot, Wt, A2(Ut, "generatorData", fe)), be = sn(f), ve = F2(function(n, r) {
        return {
            aV: n,
            a5: r
        };
    }), le = bt, de = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $e = F2(function(n, r) {
        return {
            s: r,
            t: n,
            C: f
        };
    }), he = $e(de(6))(1), ge = {
        H: f,
        aC: "Grassland"
    }, pe = {
        l: $e(de(1))(1),
        R: "",
        ae: wr,
        af: wr,
        C: "",
        E: "",
        M: 3
    }, me = {
        T: f,
        Z: ""
    }, ye = $e(de(5)), we = {
        l: ye(1),
        R: "1d20",
        bq: wr,
        C: ""
    }, Ae = {
        z: "",
        Q: 0,
        A: we,
        x: {
            af: wr,
            K: 3,
            L: ""
        }
    }, ke = F5(function(n, r, t, e, u) {
        return {
            B: e,
            D: t,
            y: r,
            q: u,
            G: n
        };
    }), xe = F2(function(n, r) {
        return A5(ke, r.G, r.y, r.D, r.B, n(r.q));
    }), Ee = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.G, u = r.y, a = r.D, i = r.B;
            return A2(_t, xe(r.q), t(A5(ke, e, u, a, i, n)));
        };
    }), je = F2(function(n, r) {
        return r.b ? A3(Mt, sr, r, n) : n;
    }), Le = function(n) {
        return A3(Mt, je, f, n);
    }, Ce = F2(function(n, r) {
        return Le(A2(_t, n, r));
    }), Ne = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(sr, n.a, Ne(n.b)) : f;
    }, Me = F2(function(n, r) {
        return yr(1 === r.$ ? v([
            n
        ]) : A2(sr, n, r.a));
    }), _e = function(n) {
        try {
            return yr(decodeURIComponent(n));
        } catch (n) {
            return wr;
        }
    }, qe = a, Ie = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return wr;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(qe, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return yr(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), Te = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), Re = {
        $: -2
    }, Oe = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Te, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5(Te, 0, e.b, e.c, A5(Te, 1, a.b, a.c, a.d, a.e), A5(Te, 1, r, t, i, u));
        }
        var i, o = u.b, c = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(Te, n, o, c, A5(Te, 0, r, t, e, f), s) : A5(Te, 0, r, t, A5(Te, 1, e.b, e.c, e.d, i = e.e), A5(Te, 1, o, c, f, s));
    }), ze = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Te, 0, n, r, Re, Re);
        var e = t.a, u = t.b, a = t.c, i = t.d, o = t.e;
        switch(A2(qe, n, u)){
            case 0:
                return A5(Oe, e, u, a, A3(ze, n, r, i), o);
            case 1:
                return A5(Te, e, u, r, i, o);
            default:
                return A5(Oe, e, u, a, i, A3(ze, n, r, o));
        }
    }), De = F3(function(n, r, t) {
        var e = A3(ze, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Te, 1, e.b, e.c, e.d, e.e);
    }), Fe = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, o = t.c, e = t.d, s = t.e, A5(Te, 1, n.b, n.c, A5(Te, 0, r.b, r.c, r.d, r.e), A5(Te, 0, i, o, e, s));
            }
            var e, u = n.d, a = n.e, i = a.b, o = a.c, c = (e = a.d).d, f = e.e, s = a.e;
            return A5(Te, 0, e.b, e.c, A5(Te, 1, n.b, n.c, A5(Te, 0, u.b, u.c, u.d, u.e), c), A5(Te, 1, i, o, f, s));
        }
        return n;
    }, Ge = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, b = t.d, v = t.e, A5(Te, 1, e = n.b, u = n.c, A5(Te, 0, r.b, r.c, r.d, o = r.e), A5(Te, 0, f, s, b, v));
            }
            var e = n.b, u = n.c, a = n.d, i = a.d, o = a.e, c = n.e, f = c.b, s = c.c, b = c.d, v = c.e;
            return A5(Te, 0, a.b, a.c, A5(Te, 1, i.b, i.c, i.d, i.e), A5(Te, 1, e, u, o, A5(Te, 0, f, s, b, v)));
        }
        return n;
    }, Se = F7(function(n, r, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return Ge(r);
                        break n;
                    }
                    return Ge(r);
                }
                break n;
            }
            return r;
        }
        return A5(Te, t, a.b, a.c, a.d, A5(Te, 0, e, u, a.e, i));
    }), Je = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var o = Fe(n);
                    if (-1 === o.$) {
                        var c = o.e;
                        return A5(Oe, o.a, o.b, o.c, Je(o.d), c);
                    }
                    return Re;
                }
                return A5(Te, r, t, e, Je(u), i);
            }
            return A5(Te, r, t, e, Je(u), i);
        }
        return Re;
    }, Be = F2(function(n, r) {
        if (-2 === r.$) return Re;
        var t = r.a, e = r.b, a = r.c, i = r.d, o = r.e;
        if (0 > u(n, e)) {
            if (-1 === i.$ && 1 === i.a) {
                var c = i.d;
                if (-1 !== c.$ || c.a) {
                    var f = Fe(r);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(Oe, f.a, f.b, f.c, A2(Be, n, f.d), s);
                    }
                    return Re;
                }
                return A5(Te, t, e, a, A2(Be, n, i), o);
            }
            return A5(Te, t, e, a, A2(Be, n, i), o);
        }
        return A2(Qe, n, A7(Se, n, r, t, e, a, i, o));
    }), Qe = F2(function(n, r) {
        if (-1 === r.$) {
            var e = r.a, u = r.b, a = r.c, i = r.d, o = r.e;
            if (t(n, u)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(o);
                return -1 === c.$ ? A5(Oe, e, c.b, c.c, i, Je(o)) : Re;
            }
            return A5(Oe, e, u, a, i, A2(Be, n, o));
        }
        return Re;
    }), He = F2(function(n, r) {
        var t = A2(Be, n, r);
        return -1 !== t.$ || t.a ? t : A5(Te, 1, t.b, t.c, t.d, t.e);
    }), Pe = F3(function(n, r, t) {
        var e = r(A2(Ie, n, t));
        return e.$ ? A2(He, n, t) : A3(De, n, e.a, t);
    }), We = F2(function(n, r) {
        var t = A2(jr, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = _e(t.a);
            if (1 === u.$) return r;
            var a = u.a, i = _e(e);
            return 1 === i.$ ? r : A3(Pe, a, Me(i.a), r);
        }
        return r;
    }), Ke = Re, Ze = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.y;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return yr(r.q);
                    }
                    return yr(r.q);
                }
                return wr;
            }
        }(n(A5(ke, f, function(n) {
            var r = A2(jr, "/", n);
            return Ne(r.b && "" === r.a ? r.b : r);
        }(r.aT), 1 === (t = r.a_).$ ? Ke : A3(Mt, We, Ke, A2(jr, "&", t.a)), r.aN, bt)));
    }), Ue = function(n) {
        return function(r) {
            var e = r.G, u = r.y, a = r.D, i = r.B, o = r.q;
            if (u.b) {
                var c = u.a, s = u.b;
                return t(c, n) ? v([
                    A5(ke, A2(sr, c, e), s, a, i, o)
                ]) : f;
            }
            return f;
        };
    }, Ye = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ve = vn, Xe = F2(function(n, r) {
        var t, e = r.b;
        return i(o(n, {
            g: (t = r.a, {
                $: 4,
                a: t
            })
        }), A2(Ve, Ye, e));
    }), nu = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ru = F2(function(n, r) {
        var t, e = r.b;
        return i(o(n, {
            g: (t = r.a, {
                $: 6,
                a: t
            })
        }), A2(Ve, nu, e));
    }), tu = {
        $: 2
    }, eu = function(n) {
        return i(o(n, {
            g: tu
        }), be);
    }, uu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, au = F2(function(n, r) {
        var t, e = r.b;
        return i(o(n, {
            g: (t = r.a, {
                $: 3,
                a: t
            })
        }), A2(Ve, uu, e));
    }), iu = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ou = F2(function(n, r) {
        var t, e = r.b;
        return i(o(n, {
            g: (t = r.a, {
                $: 7,
                a: t
            })
        }), A2(Ve, iu, e));
    }), cu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, fu = F2(function(n, r) {
        var t, e = r.b;
        return i(o(n, {
            g: (t = r.a, {
                $: 5,
                a: t
            })
        }), A2(Ve, cu, e));
    }), su = function(n) {
        return v([
            n
        ]);
    }, bu = F2(function(n, r) {
        var t, e, u = (t = v([
            A2(Ee, eu(r), su),
            A2(Ee, A2(au, r, i(pe, be)), Ue("oracle")),
            A2(Ee, A2(Xe, r, i((e = r.J, {
                u: {
                    aQ: A2(ve, he, e.aQ),
                    az: le(e.az),
                    a$: le(e.a$),
                    a9: A2(ve, he, e.a9),
                    aF: le(e.aF),
                    bc: A2(ve, he, e.bc)
                },
                ac: wr,
                U: 4,
                az: wr,
                ak: wr,
                al: f,
                am: wr
            }), be)), Ue("generator")),
            A2(Ee, A2(fu, r, i(Ae, be)), Ue("writer")),
            A2(Ee, A2(ru, r, i(ge, be)), Ue("hexcrawl")),
            A2(Ee, A2(ou, r, i(me, be)), Ue("quick-chat"))
        ]), function(n) {
            return A2(Ce, function(r) {
                return r(n);
            }, t);
        }), a = A2(Ze, u, n);
        return a.$ ? i(o(r, {
            g: Qt
        }), be) : a.a;
    }), vu = F3(function(n, r, t) {
        var e, u = A2(Ht, se, n);
        return u.$ ? i({
            J: Pt,
            ad: t,
            g: (e = Gr(u.a), {
                $: 1,
                a: e
            })
        }, be) : A2(bu, r, {
            J: u.a.J,
            ad: t,
            g: Qt
        });
    }), lu = sn(f), du = er, $u = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + xr(n.a);
    }), hu = F3(function(n, r, t) {
        return 1 === r.$ ? t : c(t, c(n, r.a));
    }), gu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, pu = function(n) {
        return {
            $: 11,
            a: n
        };
    }, mu = function(n) {
        return {
            $: 9,
            a: n
        };
    }, yu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, wu = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Au = {
        $: 0
    }, ku = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), xu = function(n) {
        var r = n.b;
        return A2(ku, 1664525 * n.a + r >>> 0, r);
    }, Eu = function(n) {
        var r = n.a, t = 277803737 * (r ^ r >>> 4 + (r >>> 28));
        return (t >>> 22 ^ t) >>> 0;
    }, ju = F2(function(n, r) {
        return function(t) {
            var e = 0 > u(n, r) ? i(n, r) : i(r, n), a = e.a, o = e.b - a + 1;
            if (o - 1 & o) {
                var c = (-o >>> 0) % o >>> 0;
                return function(n) {
                    for(;;){
                        var r = Eu(n), t = xu(n);
                        if (u(r, c) >= 0) return i(r % o + a, t);
                        n = t;
                    }
                }(t);
            }
            return i(((o - 1 & Eu(t)) >>> 0) + a, xu(t));
        };
    }), Lu = F4(function(n, r, t, e) {
        for(;;){
            if (1 > r) return i(n, e);
            var u = t(e), a = u.b;
            n = A2(sr, u.a, n), r -= 1, e = a;
        }
    }), Cu = F2(function(n, r) {
        var t = r;
        return function(r) {
            return A4(Lu, f, n, t, r);
        };
    }), Nu = function(n) {
        if (1 === n.$) return n.a;
        switch(n.a){
            case 0:
                return 4;
            case 1:
                return 6;
            case 2:
                return 8;
            case 3:
                return 10;
            case 4:
                return 12;
            case 5:
                return 20;
            default:
                return 100;
        }
    }, Mu = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r), u = e.b;
            return i(n(e.a), u);
        };
    }), _u = function(n) {
        var r = n.t, t = n.s, e = n.C;
        return A2(Mu, function(n) {
            return {
                s: t,
                t: Nu(r),
                C: e,
                aw: n
            };
        }, function(n) {
            var r = n.s, t = A2(ju, 1, Nu(n.t));
            return A2(Cu, r, t);
        }(n));
    }, qu = function(n) {
        return A3(Cr, mr, 0, n);
    }, Iu = function(n) {
        return qu(n.aw) + qu(n.C);
    }, Tu = function(n) {
        return A2(Mu, Iu, _u(n));
    }, Ru = (St = bt, U(function(n) {
        n(Z(St(Date.now())));
    })), Ou = A2(qt, function(n) {
        var r, t;
        return Lt((r = n, t = xu(A2(ku, 0, 1013904223)), xu(A2(ku, t.a + r >>> 0, t.b))));
    }, Ru), zu = F2(function(n, r) {
        return n(r);
    }), Du = F3(function(n, r, t) {
        if (r.b) {
            var e = r.b, u = A2(zu, r.a, t), a = u.b;
            return A2(qt, function() {
                return A3(Du, n, e, a);
            }, A2(Rt, n, u.a));
        }
        return Lt(t);
    }), Fu = F3(function(n, r, t) {
        return Lt(t);
    }), Gu = F2(function(n, r) {
        return A2(Mu, n, r);
    });
    un.Random = an(Ou, Du, Fu, Gu);
    var Su, Ju, Bu, Qu, Hu, Pu, Wu, Ku, Zu, Uu, Yu, Vu, Xu = fn("Random"), na = F2(function(n, r) {
        return Xu(A2(Mu, n, r));
    }), ra = F2(function(n, r) {
        return A3(Mt, F2(function(r, t) {
            return n(r) ? A2(sr, r, t) : t;
        }), f, r);
    }), ta = function(n) {
        return n.b ? yr(n.a) : wr;
    }, ea = F2(function(n, r) {
        return ta(A2(ra, n, r));
    }), ua = F2(function(n, r) {
        return A2(ea, function(r) {
            return 1 > u(r.a3, n) && 1 > u(n, r.aL);
        }, r);
    }), aa = F2(function(n, r) {
        return r.$ ? wr : yr(n(r.a));
    }), ia = F2(function(n, r) {
        return A2(Mu, function(n) {
            return A2(aa, function(r) {
                return {
                    as: r,
                    av: n
                };
            }, A2(ua, n, r));
        }, n);
    }), oa = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? wr : yr(A2(n, r.a, t.a));
    }), ca = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r), a = t.a, o = u(t.b), c = o.b;
            return i(A2(n, a, o.a), c);
        };
    }), fa = F2(function(n, r) {
        return i(n, r);
    }), sa = F2(function(n, r) {
        var t = r.a5, e = A2(Mu, function(n) {
            return A2(aa, function(r) {
                return {
                    as: r,
                    av: n
                };
            }, A2(ua, n, t));
        }, Tu(r.aV));
        return A2(na, n, e);
    }), ba = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), va = F3(function(n, r, t) {
        return A2(sa, function(t) {
            return A2(ba, n, A2(aa, r, t));
        }, t);
    }), la = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(sr, e.a, t);
    }), da = F2(function(n, r) {
        return A3(Mt, la(n), f, r);
    }), $a = F2(function(n, r) {
        return A3(ca, F2(function(n, r) {
            return i(n, r);
        }), n, r);
    }), ha = function(n) {
        return i(1, n);
    }, ga = function(n) {
        return 0 > n ? -n : n;
    }, pa = F2(function(n, r) {
        return function(t) {
            var e = xu(t), u = ga(r - n), a = Eu(e);
            return i((1 * (67108863 & Eu(t)) * 134217728 + 1 * (134217727 & a)) / 9007199254740992 * u + n, xu(e));
        };
    }), ma = F3(function(n, r, t) {
        for(;;){
            var e = n.a, a = n.b;
            if (!r.b) return a;
            var i = r.a, o = r.b;
            if (1 > u(t, ga(e))) return a;
            n = i, r = o, t -= ga(e);
        }
    }), ya = F2(function(n, r) {
        var t = function(n) {
            return ga(n.a);
        }, e = t(n) + qu(A2(_t, t, r));
        return A2(Mu, A2(ma, n, r), A2(pa, 0, e));
    }), wa = A2(F2(function(n, r) {
        return A2(ya, ha(n), A2(_t, ha, r));
    }), 0, v([
        1,
        2,
        3,
        4
    ])), Aa = A2(Mu, function(n) {
        return 100 * n.a + n.b;
    }, A2($a, A2(Mu, function(n) {
        switch(n){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            default:
                return 4;
        }
    }, wa), A2(ju, 1, 99))), ka = F2(function(n, r) {
        return A2(Mu, da(bt), A2(Cu, n, A2(Mu, function(n) {
            return A2(aa, function(r) {
                return {
                    as: r,
                    av: n
                };
            }, A2(ua, n, r));
        }, Aa)));
    }), xa = F3(function(n, r, t) {
        return A2(na, r, A2(ka, n, t));
    }), Ea = F2(function(n, r) {
        var t = va(Au);
        switch(n.$){
            case 0:
                return i(r, be);
            case 1:
                return i(r, A2(t, gu, r.u.aQ));
            case 2:
                return i(o(r, {
                    ac: yr(n.a)
                }), be);
            case 3:
                return i(r, A2(t, yu, r.u.a9));
            case 4:
                return i(o(r, {
                    ak: yr(n.a)
                }), be);
            case 5:
                return i(r, A2(t, wu, r.u.bc));
            case 6:
                return i(o(r, {
                    am: yr(n.a)
                }), be);
            case 7:
                return i(o(r, {
                    U: n.a
                }), be);
            case 8:
                return i(r, A3(xa, r.U, mu, r.u.aF));
            case 9:
                return i(o(r, {
                    al: n.a
                }), be);
            case 10:
                var e = A2(ia, Tu(he), r.u.a$), u = A2(ia, Tu(he), r.u.az), a = A3(ca, oa(fa), u, e);
                return i(r, A2(na, function(n) {
                    return A2(ba, Au, A2(aa, pu, n));
                }, a));
            default:
                return i(o(r, {
                    az: yr(n.a)
                }), be);
        }
    }), ja = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), La = F3(function(n, r, t) {
        return r(n(t));
    }), Ca = {
        a: 0,
        b: 0
    }, Na = (Su = {
        _: i(0, -1),
        aa: i(-1, -1),
        ab: i(1, -1),
        ah: i(0, 1),
        ai: i(-1, 1),
        aj: i(1, 1)
    }, Ju = F2(function(n, r) {
        return o(r, {
            a: r.a + n.a,
            b: r.b + n.b
        });
    }), {
        _: Ju(Su._),
        aa: Ju(Su.aa),
        ab: Ju(Su.ab),
        ah: Ju(Su.ah),
        ai: Ju(Su.ai),
        aj: Ju(Su.aj)
    }), Ma = F2(function(n, r) {
        var t = n;
        return v([
            t.ah(r),
            t.aj(r),
            t.ab(r),
            t._(r),
            t.aa(r),
            t.ai(r)
        ]);
    }), _a = (Bu = v([
        {
            a: 0,
            b: 2
        },
        {
            a: 1,
            b: 2
        },
        {
            a: 2,
            b: 2
        },
        {
            a: 2,
            b: 0
        },
        {
            a: 2,
            b: -2
        },
        {
            a: 1,
            b: -2
        },
        {
            a: 0,
            b: -2
        },
        {
            a: -1,
            b: -2
        },
        {
            a: -2,
            b: -2
        },
        {
            a: -2,
            b: 0
        },
        {
            a: -2,
            b: 2
        },
        {
            a: -1,
            b: 2
        }
    ]), Le(v([
        A2(Ma, Na, Ca),
        Bu
    ]))), qa = $e(de(3))(1), Ia = le(v([
        {
            aL: 5,
            aM: "Same as previous hex",
            a3: 1
        },
        {
            aL: 6,
            aM: "Grassland",
            a3: 6
        },
        {
            aL: 7,
            aM: "Forest",
            a3: 7
        },
        {
            aL: 8,
            aM: "Hills",
            a3: 8
        },
        {
            aL: 9,
            aM: "Marsh",
            a3: 9
        },
        {
            aL: 10,
            aM: "Mountains",
            a3: 10
        }
    ])), Ta = le(v([
        {
            aL: 4,
            aM: "Grassland",
            a3: 1
        },
        {
            aL: 6,
            aM: "Forest",
            a3: 5
        },
        {
            aL: 8,
            aM: "Hills",
            a3: 7
        },
        {
            aL: 9,
            aM: "Marsh",
            a3: 9
        },
        {
            aL: 10,
            aM: "Mountains",
            a3: 10
        }
    ])), Ra = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return i(o(r, {
                H: (e = A2(sr, t, n.b), Dr(A3(Cr, F2(function(n, r) {
                    return r.b ? A2(sr, "Same as previous hex" === n ? r.a : n, r) : v([
                        n
                    ]);
                }), f, e))),
                aC: t
            }), be);
        }
        var e, u = A2(Mu, function(n) {
            return A2(ba, "Grassland", A2(aa, A2(La, function(n) {
                return n.as;
            }, function(n) {
                return n.aM;
            }), n));
        }, A2(ia, Tu(qa), Ta)), a = A2(Mu, da(function(n) {
            return A2(aa, A2(La, function(n) {
                return n.as;
            }, function(n) {
                return n.aM;
            }), n);
        }), A2(Cu, Nr(_a), A2(ia, Tu(qa), Ia)));
        return i(r, A2(na, bt, A3(ca, ja, u, a)));
    }), Oa = function(n) {
        return {
            $: 8,
            a: n
        };
    }, za = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Da = F3(function(n, r, t) {
        return 0 > u(t, n) ? n : u(t, r) > 0 ? r : t;
    }), Fa = function(n) {
        switch(n){
            case 0:
                return -8;
            case 1:
                return -5;
            case 2:
                return -3;
            case 3:
                return 0;
            case 4:
                return 3;
            case 5:
                return 5;
            default:
                return 8;
        }
    }, Ga = F2(function(n, r) {
        return o(r, {
            C: n
        });
    }), Sa = function(n) {
        return A2(Mu, function(n) {
            var r = A3(Da, 1, 20, n);
            return i(r, function(n) {
                return A2(ba, 6, function(n) {
                    return 1 === n || 2 === n ? yr(0) : n > 7 ? 8 === n || 9 === n ? yr(2) : 10 === n ? yr(3) : 11 === n || 12 === n ? yr(4) : n > 18 ? 19 === n || 20 === n ? yr(6) : wr : yr(5) : yr(1);
                }(n));
            }(r));
        }, Tu(A2(Ga, v([
            Fa(n)
        ]), ye(1))));
    }, Ja = F2(function(n, r) {
        return r.$ ? wr : n(r.a);
    }), Ba = F4(function(n, r, t, e) {
        return {
            bn: r,
            bp: n,
            av: t,
            bC: e
        };
    }), Qa = (Qu = A2(ar, {
        bf: !1,
        br: !1
    }, "(\\d+)[dD](\\d+)")).$ ? {
        $: 1
    } : {
        $: 0,
        a: Qu.a
    }, Ha = ir(1 / 0), Pa = function(n) {
        if (Qa.$) return wr;
        var r = A2(ba, f, A2(aa, function(n) {
            return A2(da, Ja(mt), n.bC);
        }, ta(A2(Ha, Qa.a, n))));
        if (r.b && r.b.b && !r.b.b.b) {
            var t = r.a;
            return yr(A2($e, function(n) {
                switch(n){
                    case 4:
                        return de(0);
                    case 6:
                        return de(1);
                    case 8:
                        return de(2);
                    case 10:
                        return de(3);
                    case 12:
                        return de(4);
                    case 20:
                        return de(5);
                    case 100:
                        return de(6);
                    default:
                        return {
                            $: 1,
                            a: n
                        };
                }
            }(r.b.a), t));
        }
        return wr;
    }, Wa = D, Ka = function(n) {
        var r, t = "[" + n + "]";
        return (r = A2(Wa, ne(ae), t)).$ ? wr : yr(r.a);
    }, Za = F2(function(n, r) {
        return o(r, {
            s: n.s,
            t: n.t
        });
    }), Ua = F2(function(n, r) {
        switch(n.$){
            case 0:
                return i(r, be);
            case 1:
                var t = A2(na, za, Sa(r.M));
                return i(r, t);
            case 2:
                return i(o(r, {
                    E: n.a
                }), be);
            case 3:
                return i(o(r, {
                    M: n.a
                }), be);
            case 4:
                var e = n.a;
                return i(o(r, {
                    af: yr({
                        an: e.b,
                        at: r.M,
                        E: r.E,
                        aA: e.a
                    })
                }), be);
            case 5:
                var u = n.a, a = (s = Pa(u)).$ ? r.l : A2(Za, s.a, r.l);
                return i(o(r, {
                    l: a,
                    R: u
                }), be);
            case 6:
                var c = n.a;
                return i(o(r, {
                    l: a = (f = Ka(c)).$ ? r.l : A2(Ga, f.a, r.l),
                    C: c
                }), be);
            case 7:
                return i(r, t = A2(na, Oa, _u(r.l)));
            default:
                return i(o(r, {
                    ae: yr(n.a)
                }), be);
        }
        var f, s;
    }), Ya = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Va = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xa = function(n) {
        return function(r) {
            return i(n, r);
        };
    }, ni = function(n) {
        var r = n.t, t = n.C;
        return xr(n.s) + "d" + (xr(Nu(r)) + A2(Er, "", A2(_t, function(n) {
            return 0 > n ? xr(n) : "+" + xr(n);
        }, t)));
    }, ri = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ti = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ei = function(n) {
        var r = v(n.trim().split(/\s+/g));
        n: for(;;){
            if (r.b && "/r" === r.a && r.b.b) {
                if (r.b.b.b) {
                    if (r.b.b.b.b) break n;
                    var t = r.b, e = (u = t.a, t.b.a);
                    return A2(ba, ti(n), A3(oa, F2(function(n, r) {
                        return ri(A2(Ga, r, n));
                    }), Pa(u), Ka(e)));
                }
                var u = r.b.a;
                return A2(ba, ti(n), A2(aa, ri, Pa(u)));
            }
            break n;
        }
        return ti(n);
    }, ui = function(n) {
        return "( " + A2(Er, ", ", A2(_t, xr, n)) + " )";
    }, ai = A2(Mt, ca(sr), Xa(f)), ii = F2(function(n, r) {
        switch(n.$){
            case 0:
                return i(o(r, {
                    Z: n.a
                }), be);
            case 1:
                return i(o(r, {
                    T: A2(je, r.T, A2(_t, function(n) {
                        if (n.$) {
                            var r = n.b;
                            return ni(n.a) + " ==> " + xr(Iu(r)) + " " + ui(r.aw);
                        }
                        return n.a;
                    }, n.a))
                }), be);
            default:
                var t = A2(_t, ei, v(r.Z.split(/\r\n|\r|\n/g)));
                return i(r, A2(na, Va, ai(A2(_t, function(n) {
                    if (1 === n.$) return Xa({
                        $: 0,
                        a: n.a
                    });
                    var r = n.a;
                    return A2(Mu, function(n) {
                        return A2(Ya, r, n);
                    }, _u(r));
                }, t))));
        }
    }), oi = function(n) {
        return {
            $: 12,
            a: n
        };
    }, ci = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), fi = F2(function(n, r) {
        return o(r, {
            z: "" === r.z ? n : r.z + "\n\n" + n
        });
    }), si = bt, bi = si(function(n) {
        var r;
        return A2(Er, "\n", v([
            "#### Dice roll",
            "",
            "**Description**",
            "",
            "* Roll: " + (r = ni(n.l), "`" + r + "`"),
            "* Score: " + xr(Iu(n.ao)),
            "* Result: " + ui(n.ao.aw)
        ]));
    }), vi = function(n) {
        switch(n){
            case 0:
                return "No, and";
            case 1:
                return "No";
            case 2:
                return "No, but";
            case 3:
                return "Maybe";
            case 4:
                return "Yes, but";
            case 5:
                return "Yes";
            default:
                return "Yes, and";
        }
    }, li = function(n) {
        switch(n){
            case 0:
                return "Impossible";
            case 1:
                return "Highly unlikely";
            case 2:
                return "Unlikely";
            case 3:
                return "Possible";
            case 4:
                return "Likely";
            case 5:
                return "Highly likely";
            default:
                return "A certainly";
        }
    }, di = si(function(n) {
        var r, t = 0 > (r = Fa(n.at)) ? xr(r) : "+" + xr(r), e = li(n.at) + " (" + t + ")";
        return A2(Er, "\n", v([
            "#### Oracle",
            "",
            "* **Question**: " + n.E,
            "* Score: " + xr(n.aA),
            "* Answer: " + vi(n.an),
            "* Likelihood: " + e
        ]));
    }), $i = F2(function(n, r) {
        return n(r);
    }), hi = F2(function(n, r) {
        return o(r, {
            A: n
        });
    }), gi = F2(function(n, r) {
        return o(r, {
            x: n
        });
    }), pi = F2(function(n, r) {
        var t, e, u, a = r.A, c = r.x;
        switch(n.$){
            case 0:
                return i(r, be);
            case 1:
                return i(o(r, {
                    Q: n.a
                }), be);
            case 4:
                var f = A2(na, function(n) {
                    return A2(ci, n.a, n.b);
                }, Sa(c.K));
                return i(r, f);
            case 2:
                return i(A2(gi, o(c, {
                    L: n.a
                }), r), be);
            case 3:
                return i(A2(gi, o(c, {
                    K: n.a
                }), r), be);
            case 5:
                return i(A2(gi, o(c, {
                    af: yr({
                        an: n.b,
                        at: c.K,
                        E: c.L,
                        aA: n.a
                    })
                }), r), be);
            case 6:
                return i(A2(fi, A2($i, di, n.a), r), be);
            case 7:
                return i(o(r, {
                    z: n.a
                }), be);
            case 8:
                return i(A2(hi, we, r), be);
            case 9:
                var s = n.a, b = (u = Pa(s)).$ ? a : o(a, {
                    l: A2(Za, u.a, a.l),
                    R: s,
                    bq: wr
                });
                return i(A2(hi, b, r), be);
            case 10:
                var v = n.a;
                return b = (e = Ka(v)).$ ? a : o(a, {
                    l: A2(Ga, e.a, a.l),
                    bq: wr,
                    C: v
                }), i(A2(hi, b, r), be);
            case 11:
                return i(r, f = A2(na, oi, _u(a.l)));
            case 12:
                return i(A2(hi, o(a, {
                    bq: yr(n.a)
                }), r), be);
            default:
                return i((t = a.bq).$ ? r : A2(fi, A2($i, bi, {
                    l: a.l,
                    ao: t.a
                }), r), be);
        }
    }), mi = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return i(r, t.$ ? (b = t.a, A2(Bt, jt, U(function() {
                    try {
                        ur.location = b;
                    } catch (n) {
                        pn.location.reload(!1);
                    }
                }))) : A2(du, r.ad, function(n) {
                    return A3(hu, "#", n.aN, A3(hu, "?", n.a_, c(A2($u, n.aW, c(n.aZ ? "https://" : "http://", n.aP)), n.aT)));
                }(t.a)));
            case 1:
                return A2(bu, n.a, r);
            case 2:
                var e = n.a, u = r.g;
                return 3 === u.$ ? A2(au, r, A2(Ua, e, u.a)) : i(r, be);
            case 3:
                e = n.a;
                var a = r.g;
                return 4 === a.$ ? A2(Xe, r, A2(Ea, e, a.a)) : i(r, be);
            case 4:
                e = n.a;
                var o = r.g;
                return 5 === o.$ ? A2(fu, r, A2(pi, e, o.a)) : i(r, be);
            case 5:
                e = n.a;
                var f = r.g;
                return 6 === f.$ ? A2(ru, r, A2(Ra, e, f.a)) : i(r, be);
            default:
                e = n.a;
                var s = r.g;
                return 7 === s.$ ? A2(ou, r, A2(ii, e, s.a)) : i(r, be);
        }
        var b;
    }), yi = M, wi = wn("a"), Ai = wn("div"), ki = K, xi = F2(function(n, r) {
        return A2(En, n, ki(r));
    }), Ei = function(n) {
        var r;
        return A2(xi, "href", Cn.test(r = n) ? "" : r);
    }, ji = yn, Li = A2(Ai, f, v([
        A2(wi, v([
            Ei("/")
        ]), v([
            ji("Back to top")
        ]))
    ])), Ci = function(n) {
        return n + " | Old Troll's Adventure";
    }, Ni = kn, Mi = F2(function(n, r) {
        return {
            aI: A2(_t, Ni(n), r.aI),
            a7: r.a7
        };
    }), _i = {
        $: 1
    }, qi = {
        $: 8
    }, Ii = {
        $: 3
    }, Ti = {
        $: 5
    }, Ri = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Oi = xi("className"), zi = wn("p"), Di = function(n) {
        return A2(zi, f, v([
            ji(n.bj)
        ]));
    }, Fi = wn("h1"), Gi = wn("li"), Si = wn("ol"), Ji = function(n) {
        var r = function(n) {
            return A2(Gi, f, v([
                ji(n)
            ]));
        };
        return A2(Ai, f, v([
            A2(Si, f, v([
                r(n.bE),
                r(n.bF),
                r(n.bG),
                r(n.bH)
            ]))
        ]));
    }, Bi = {
        $: 10
    }, Qi = wn("button"), Hi = wn("h3"), Pi = xn, Wi = F2(function(n, r) {
        return A2(Pi, n, {
            $: 0,
            a: r
        });
    }), Ki = function(n) {
        return A2(Wi, "click", ft(n));
    }, Zi = wn("span"), Ui = wn("strong"), Yi = wn("ul"), Vi = function(n) {
        return A2(Ai, v([
            Oi("box")
        ]), v([
            A2(Hi, v([
                Oi("title is-5")
            ]), v([
                ji("Quest")
            ])),
            function() {
                var r = n.az;
                if (r.$) return ji("");
                var t = r.a, e = t.a, u = t.b, a = e.as.aM;
                return A2(Ai, v([
                    Oi("content")
                ]), v([
                    A2(Yi, f, v([
                        A2(Gi, f, v([
                            A2(Ui, f, v([
                                ji("Problem: ")
                            ])),
                            A2(Zi, f, v([
                                ji(a.bA)
                            ])),
                            A2(Zi, f, v([
                                ji(" (" + xr(e.av) + ")")
                            ]))
                        ])),
                        A2(Gi, f, v([
                            A2(Ui, f, v([
                                ji("Goal: ")
                            ])),
                            A2(Zi, f, v([
                                ji(a.az)
                            ]))
                        ])),
                        A2(Gi, f, v([
                            A2(Ui, f, v([
                                ji("Source: ")
                            ])),
                            A2(Zi, f, v([
                                ji(u.as.aM)
                            ])),
                            A2(Zi, f, v([
                                ji(" (" + xr(u.av) + ")")
                            ]))
                        ]))
                    ]))
                ]));
            }(),
            A2(Ai, v([
                Oi("buttons")
            ]), v([
                A2(Qi, v([
                    Oi("button is-info"),
                    Ki(Bi)
                ]), v([
                    ji("Generate")
                ]))
            ]))
        ]));
    }, Xi = wn("section"), no = F3(function(n, r, t) {
        if (t.$) return ji("");
        var e = t.a;
        return A2(Ai, v([
            Oi("content")
        ]), v([
            A2(zi, f, v([
                A2(Ui, f, v([
                    ji(r)
                ]))
            ])),
            A2(zi, f, v([
                A2(Zi, f, v([
                    ji("(Result: "),
                    ji(xr(e.av)),
                    ji(")")
                ]))
            ])),
            n(e.as.aM)
        ]));
    }), ro = F2(function(n, r) {
        return A2(Ai, v([
            Oi("box")
        ]), v([
            A2(Hi, v([
                Oi("title is-5")
            ]), v([
                ji(n.ar)
            ])),
            A3(no, n.aE, n.ap, r),
            A2(Ai, v([
                Oi("buttons")
            ]), v([
                A2(Qi, v([
                    Oi("button is-info"),
                    Ki(n.ag)
                ]), v([
                    ji("Generate")
                ]))
            ]))
        ]));
    }), to = wn("input"), eo = wn("label"), uo = xi("max"), ao = xi("min"), io = function(n) {
        return i(n, !0);
    }, oo = F2(function(n, r) {
        return A2(Pi, n, {
            $: 1,
            a: r
        });
    }), co = A2(F2(function(n, r) {
        return A3(Mt, Ut, r, n);
    }), v([
        "target",
        "value"
    ]), Yt), fo = function(n) {
        return A2(oo, "input", A2(ot, io, A2(ot, n, co)));
    }, so = xi("type"), bo = xi("value"), vo = F3(function(n, r, t) {
        return A2(Ai, v([
            Oi("box")
        ]), v([
            A2(Hi, v([
                Oi("title is-5")
            ]), v([
                ji("Verbs")
            ])),
            A2(Ai, v([
                Oi("field")
            ]), v([
                A2(eo, v([
                    Oi("label")
                ]), v([
                    ji("How many verbs?")
                ])),
                A2(zi, v([
                    Oi("control")
                ]), v([
                    A2(to, v([
                        so("number"),
                        Oi("input"),
                        ao("1"),
                        uo("10"),
                        bo(xr(r)),
                        fo(function(t) {
                            return n.bv(A2(ba, r, mt(t)));
                        })
                    ]), f)
                ]))
            ])),
            function() {
                if (t.b) {
                    var n = t;
                    return A2(Ai, v([
                        Oi("content")
                    ]), v([
                        A2(Si, f, A2(_t, function(n) {
                            return A2(Gi, f, v([
                                A2(Zi, f, v([
                                    ji(n.as.aM.aF)
                                ])),
                                A2(Zi, f, v([
                                    ji(" ["),
                                    ji(xr(n.av)),
                                    ji("]")
                                ]))
                            ]));
                        }, n))
                    ]));
                }
                return ji("");
            }(),
            A2(Ai, v([
                Oi("buttons")
            ]), v([
                A2(Qi, v([
                    Oi("button is-info"),
                    Ki(n.ag)
                ]), v([
                    ji("Generate Verbs")
                ]))
            ]))
        ]));
    }), lo = {
        $: 0
    }, $o = F2(function(n, r) {
        return A2(jn, function(n) {
            return Ln.test(n) ? "data-" + n : n;
        }(n), function(n) {
            return Nn.test(n) ? "" : n;
        }(r));
    }), ho = wn("main"), go = v([
        v([
            Pu = wr,
            Pu,
            A2(Hu = F2(function(n, r) {
                return yr("(" + xr(n) + "," + xr(r) + ")");
            }), 0, 2),
            Pu,
            Pu
        ]),
        v([
            Pu,
            A2(Hu, -1, 2),
            Pu,
            A2(Hu, 1, 2),
            Pu
        ]),
        v([
            A2(Hu, -2, 2),
            Pu,
            A2(Hu, 0, 1),
            Pu,
            A2(Hu, 2, 2)
        ]),
        v([
            Pu,
            A2(Hu, -1, 1),
            Pu,
            A2(Hu, 1, 1),
            Pu
        ]),
        v([
            A2(Hu, 2, 0),
            Pu,
            A2(Hu, 0, 0),
            Pu,
            A2(Hu, 2, 0)
        ]),
        v([
            Pu,
            A2(Hu, -1, -1),
            Pu,
            A2(Hu, 1, -1),
            Pu
        ]),
        v([
            A2(Hu, -2, -2),
            Pu,
            A2(Hu, 0, -1),
            Pu,
            A2(Hu, 2, -2)
        ]),
        v([
            Pu,
            A2(Hu, -1, -2),
            Pu,
            A2(Hu, 1, -2),
            Pu
        ]),
        v([
            Pu,
            Pu,
            A2(Hu, 0, -2),
            Pu,
            Pu
        ])
    ]), po = function(n) {
        return "(" + xr(n.a) + "," + xr(n.b) + ")";
    }, mo = wn("table"), yo = wn("tbody"), wo = wn("td"), Ao = wn("tr"), ko = Mr(fa), xo = (Wu = F2(function(n, r) {
        return A2(Gi, f, v([
            A2(wi, v([
                Ei(n)
            ]), v([
                ji(r)
            ]))
        ]));
    }), A2(Xi, v([
        Oi("section")
    ]), v([
        A2(Ai, v([
            Oi("container")
        ]), v([
            A2(Ai, v([
                Oi("content")
            ]), v([
                A2(Yi, f, v([
                    A2(Wu, "/writer", "Writing tools"),
                    A2(Wu, "/oracle", "Ask the Oracle"),
                    A2(Wu, "/generator", "Generator collection"),
                    A2(Wu, "/hexcrawl", "Hex Crawl Sandbox")
                ]))
            ]))
        ]))
    ]))), Eo = {
        aI: v([
            xo
        ]),
        a7: Ci("Top")
    }, jo = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Lo = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Co = {
        $: 7
    }, No = wn("hr"), Mo = {
        $: 1
    }, _o = function(n) {
        return {
            $: 2,
            a: n
        };
    }, qo = {
        $: 0
    }, Io = wn("article"), To = function(n) {
        switch(n){
            case "imp":
                return yr(0);
            case "hul":
                return yr(1);
            case "unl":
                return yr(2);
            case "pos":
                return yr(3);
            case "lky":
                return yr(4);
            case "hil":
                return yr(5);
            case "ace":
                return yr(6);
            default:
                return wr;
        }
    }, Ro = wn("option"), Oo = K, zo = F2(function(n, r) {
        return A2(En, n, Oo(r));
    }), Do = zo("selected"), Fo = v([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]), Go = function(n) {
        switch(n){
            case 0:
                return "imp";
            case 1:
                return "hul";
            case 2:
                return "unl";
            case 3:
                return "pos";
            case 4:
                return "lky";
            case 5:
                return "hil";
            default:
                return "ace";
        }
    }, So = xi("placeholder"), Jo = wn("select"), Bo = function(n) {
        var r;
        return A2(Xi, f, v([
            A2(Ai, f, v([
                A2(zi, f, v([
                    A2(eo, f, v([
                        ji("Question")
                    ]))
                ])),
                A2(zi, f, v([
                    A2(to, v([
                        so("text"),
                        So("Enter your question"),
                        fo(_o)
                    ]), f)
                ]))
            ])),
            A2(Ai, f, v([
                A2(Jo, v([
                    A2(Wi, "change", A2(ot, function(n) {
                        var r = To(n);
                        return r.$ ? qo : {
                            $: 3,
                            a: r.a
                        };
                    }, co))
                ]), (r = n.M, A2(_t, function(n) {
                    return A2(Ro, v([
                        Do(t(n, r)),
                        bo(Go(n))
                    ]), v([
                        ji(li(n))
                    ]));
                }, Fo)))
            ])),
            function() {
                var r = n.af;
                if (r.$) return ji("");
                var t = r.a;
                return A2(Io, f, v([
                    A2(zi, f, v([
                        A2(Zi, f, v([
                            A2(Ui, f, v([
                                ji("Question: ")
                            ]))
                        ])),
                        A2(Zi, f, v([
                            ji(t.E)
                        ]))
                    ])),
                    A2(zi, f, v([
                        A2(Zi, f, v([
                            A2(Ui, f, v([
                                ji("Likelihood: ")
                            ]))
                        ])),
                        A2(Zi, f, v([
                            ji(li(t.at))
                        ]))
                    ])),
                    A2(zi, f, v([
                        A2(Zi, f, v([
                            A2(Ui, f, v([
                                ji("Answer: ")
                            ]))
                        ])),
                        A2(Zi, f, v([
                            ji(vi(t.an))
                        ]))
                    ])),
                    A2(zi, f, v([
                        A2(Zi, f, v([
                            ji("(Result: "),
                            ji(xr(t.aA)),
                            ji(")")
                        ]))
                    ]))
                ]));
            }(),
            A2(Ai, f, v([
                A2(Qi, v([
                    Ki(Mo)
                ]), v([
                    ji("Ask the Oracle!")
                ]))
            ]))
        ]));
    }, Qo = wn("code"), Ho = F2(function(n, r) {
        return A2(Ai, v([
            Oi("box")
        ]), v([
            A2(Ai, v([
                Oi("field has-addons")
            ]), v([
                A2(zi, v([
                    Oi("control")
                ]), v([
                    A2(Zi, v([
                        Oi("button is-static")
                    ]), v([
                        ji("Roll")
                    ]))
                ])),
                A2(zi, v([
                    Oi("control")
                ]), v([
                    A2(to, v([
                        Oi("input"),
                        so("text"),
                        So("1d6"),
                        A2(Wi, "change", A2(ot, n.bt, co)),
                        bo(r.R)
                    ]), f)
                ]))
            ])),
            A2(Ai, v([
                Oi("field has-addons")
            ]), v([
                A2(zi, v([
                    Oi("control")
                ]), v([
                    A2(Zi, v([
                        Oi("button is-static")
                    ]), v([
                        ji("Mod")
                    ]))
                ])),
                A2(zi, v([
                    Oi("control")
                ]), v([
                    A2(to, v([
                        Oi("input"),
                        so("text"),
                        So("1,2,3"),
                        A2(Wi, "change", A2(ot, n.bu, co)),
                        bo(r.C)
                    ]), f)
                ]))
            ])),
            A2(Ai, v([
                Oi("field")
            ]), v([
                A2(zi, v([
                    Oi("control")
                ]), v([
                    A2(Qi, v([
                        Oi("button is-warning is-fullwidth"),
                        Ki(n.ag)
                    ]), v([
                        ji("GO!")
                    ]))
                ]))
            ])),
            A2(Ai, f, v([
                A2(zi, f, v([
                    A2(Zi, f, v([
                        ji("Result of ")
                    ])),
                    A2(Qo, f, v([
                        ji(ni(r.l))
                    ])),
                    A2(Zi, f, v([
                        ji(": ")
                    ])),
                    ji(A2(ba, "(To be rolled)", A2(aa, A2(La, Iu, xr), r.bq))),
                    function() {
                        var n = r.bq;
                        if (n.$) return ji("");
                        var t = n.a;
                        return A2(zi, f, v([
                            A2(Zi, f, v([
                                ji("Score: ")
                            ])),
                            A2(Zi, f, v([
                                ji(ui(t.aw))
                            ]))
                        ]));
                    }()
                ]))
            ]))
        ]));
    }), Po = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Wo = {
        $: 2
    }, Ko = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Zo = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Uo = {
        $: 8
    }, Yo = {
        $: 11
    }, Vo = {
        $: 13
    }, Xo = wn("details"), nc = zo("disabled"), rc = wn("summary"), tc = function(n) {
        return A2(Xo, v([
            A2($o, "open", "")
        ]), v([
            A2(rc, f, v([
                ji("DICE BOT")
            ])),
            A2(Xi, v([
                Oi("section py-2")
            ]), v([
                A2(Ho, {
                    ag: Yo,
                    bt: Ko,
                    bu: Zo
                }, n.A)
            ])),
            A2(Ai, v([
                Oi("section py-2")
            ]), v([
                A2(Ai, v([
                    Oi("buttons")
                ]), v([
                    A2(Qi, v([
                        Oi("button"),
                        nc(t(n.A.bq, wr)),
                        n.A.bq.$ ? Oi("") : Ki(Vo)
                    ]), v([
                        ji("Add to content")
                    ])),
                    A2(Qi, v([
                        Oi("button is-light"),
                        Ki(Uo)
                    ]), v([
                        ji("Reset")
                    ]))
                ]))
            ]))
        ]));
    }, ec = function(n) {
        return {
            $: 7,
            a: n
        };
    }, uc = function(n) {
        return A2(jn, "rows", xr(n));
    }, ac = wn("textarea"), ic = function(n) {
        return A2(Ai, v([
            Oi("field")
        ]), v([
            A2(zi, v([
                Oi("control")
            ]), v([
                A2(ac, v([
                    Oi("textarea is-family-monospace"),
                    uc(28),
                    fo(ec)
                ]), v([
                    ji(n.z)
                ]))
            ]))
        ]));
    }, oc = wn("nav"), cc = {
        $: 4
    }, fc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sc = {
        $: 0
    }, bc = function(n) {
        return {
            $: 6,
            a: n
        };
    }, vc = wn("pre"), lc = F3(function(n, r, t) {
        return A2(Ai, v([
            Oi("box")
        ]), v([
            A2(Hi, v([
                Oi("title is-5")
            ]), v([
                ji("Preview")
            ])),
            A2(vc, f, v([
                A2(Qo, v([
                    Oi("has-text-black")
                ]), v([
                    ji(A2($i, r, t))
                ]))
            ])),
            A2(Ai, v([
                Oi("field mt-4")
            ]), v([
                A2(Ai, v([
                    Oi("control")
                ]), v([
                    A2(Qi, v([
                        Oi("button"),
                        Ki(n(t))
                    ]), v([
                        ji("Add to content")
                    ]))
                ]))
            ]))
        ]));
    }), dc = F3(function(n, r, e) {
        var u, a = t(n.Q, r);
        return A2(Qi, v([
            Oi("button is-text"),
            nc(a),
            a ? Oi("") : Ki((u = r, {
                $: 1,
                a: u
            }))
        ]), v([
            ji(e)
        ]));
    }), $c = wn("h2"), hc = (Zu = {
        bo: vu,
        bw: function(n) {
            return {
                $: 1,
                a: n
            };
        },
        bx: function(n) {
            return {
                $: 0,
                a: n
            };
        },
        bD: function() {
            return lu;
        },
        bI: mi,
        bJ: function(n) {
            var r, e = n.g;
            switch(e.$){
                case 0:
                    return {
                        aI: v([
                            Li
                        ]),
                        a7: Ci("Not found")
                    };
                case 1:
                    return {
                        aI: v([
                            (r = e.a, A2(Ai, f, v([
                                A2($c, f, v([
                                    ji("Initialization failed.")
                                ])),
                                A2(Ai, f, v([
                                    A2(vc, f, v([
                                        A2(Qo, f, v([
                                            ji(r)
                                        ]))
                                    ]))
                                ]))
                            ])))
                        ]),
                        a7: Ci("Error!")
                    };
                case 2:
                    return Eo;
                case 3:
                    return A2(Mi, uu, function(n) {
                        return {
                            aI: v([
                                Li,
                                Bo(n),
                                A2(No, f, f),
                                A2(Ho, {
                                    ag: Co,
                                    bt: jo,
                                    bu: Lo
                                }, {
                                    l: n.l,
                                    R: n.R,
                                    bq: n.ae,
                                    C: n.C
                                })
                            ]),
                            a7: Ci("Ask the Oracle")
                        };
                    }(e.a));
                case 4:
                    return A2(Mi, Ye, function(n) {
                        var r;
                        return {
                            aI: (r = v([
                                Li,
                                A2(Fi, v([
                                    Oi("title")
                                ]), v([
                                    ji("Random Generators")
                                ])),
                                Vi(n),
                                A2(ro, {
                                    ap: "Item or Relic",
                                    ar: "Item and Relic Name",
                                    ag: _i,
                                    aE: Ji
                                }, n.ac),
                                A2(ro, {
                                    ap: "Event",
                                    ar: "Urban Event",
                                    ag: Ii,
                                    aE: Di
                                }, n.ak),
                                A2(ro, {
                                    ap: "Event",
                                    ar: "Wilderness Event",
                                    ag: Ti,
                                    aE: Di
                                }, n.am),
                                A3(vo, {
                                    ag: qi,
                                    bv: Ri
                                }, n.U, n.al)
                            ]), v([
                                A2(Xi, v([
                                    Oi("section")
                                ]), v([
                                    A2(Ai, v([
                                        Oi("container")
                                    ]), r)
                                ]))
                            ])),
                            a7: Ci("Generators")
                        };
                    }(e.a));
                case 5:
                    return A2(Mi, cu, function(n) {
                        var r;
                        return {
                            aI: v([
                                (r = v([
                                    Li,
                                    A2(Fi, v([
                                        Oi("title")
                                    ]), v([
                                        ji("Writing Tools")
                                    ])),
                                    A2(Ai, v([
                                        Oi("columns")
                                    ]), v([
                                        A2(Ai, v([
                                            Oi("column")
                                        ]), v([
                                            ic(n)
                                        ])),
                                        A2(Ai, v([
                                            Oi("column")
                                        ]), v([
                                            A2(oc, v([
                                                Oi("buttons")
                                            ]), v([
                                                A3(dc, n, 1, "Oracle")
                                            ])),
                                            n.Q ? function(n) {
                                                var r, e;
                                                return A2(Xi, v([
                                                    Oi("section pt-1")
                                                ]), v([
                                                    A2(Ai, v([
                                                        Oi("field")
                                                    ]), v([
                                                        A2(eo, v([
                                                            Oi("label")
                                                        ]), v([
                                                            ji("YES / NO question")
                                                        ])),
                                                        A2(zi, v([
                                                            Oi("control")
                                                        ]), v([
                                                            A2(to, v([
                                                                so("text"),
                                                                Oi("input"),
                                                                So("Is the dragon sleeping?"),
                                                                bo(n.x.L),
                                                                fo(fc)
                                                            ]), f)
                                                        ]))
                                                    ])),
                                                    A2(Ai, v([
                                                        Oi("field")
                                                    ]), v([
                                                        A2(eo, v([
                                                            Oi("label")
                                                        ]), v([
                                                            ji("Likelihood")
                                                        ])),
                                                        A2(Ai, v([
                                                            Oi("control")
                                                        ]), v([
                                                            A2(Ai, v([
                                                                Oi("select")
                                                            ]), v([
                                                                A2(Jo, v([
                                                                    A2(Wi, "change", A2(ot, function(n) {
                                                                        var r = To(n);
                                                                        return r.$ ? sc : {
                                                                            $: 3,
                                                                            a: r.a
                                                                        };
                                                                    }, co))
                                                                ]), (e = n.x.K, A2(_t, function(n) {
                                                                    return A2(Ro, v([
                                                                        Do(t(n, e)),
                                                                        bo(Go(n))
                                                                    ]), v([
                                                                        ji(li(n))
                                                                    ]));
                                                                }, Fo)))
                                                            ]))
                                                        ]))
                                                    ])),
                                                    A2(Ai, v([
                                                        Oi("field is-grouped")
                                                    ]), v([
                                                        A2(zi, v([
                                                            Oi("control")
                                                        ]), v([
                                                            A2(Qi, v([
                                                                Oi("button is-success"),
                                                                nc("" === n.x.L),
                                                                Ki(cc)
                                                            ]), v([
                                                                ji("Ask the Oracle!")
                                                            ]))
                                                        ]))
                                                    ])),
                                                    (r = n.x.af, r.$ ? ji("") : A3(lc, bc, di, r.a))
                                                ]));
                                            }(n) : ji(""),
                                            tc(n)
                                        ]))
                                    ]))
                                ]), A2(ho, v([
                                    Oi("section")
                                ]), v([
                                    A2(Ai, v([
                                        Oi("container")
                                    ]), r)
                                ])))
                            ]),
                            a7: Ci("Writing Tools")
                        };
                    }(e.a));
                case 6:
                    return A2(Mi, nu, function(n) {
                        var r, t, e = function(n) {
                            var r = n.b;
                            return A2(Gi, f, v([
                                A2(Zi, f, v([
                                    ji(n.a)
                                ])),
                                ji(" "),
                                A2(Zi, f, v([
                                    ji(po(r))
                                ]))
                            ]));
                        }, u = A2(ko, n.H, A2(sr, Ca, _a)), a = (r = A2(_t, function(n) {
                            var r = n.a, t = n.b;
                            return i(po(t), {
                                bz: t,
                                a8: r
                            });
                        }, u), A3(Cr, F2(function(n, r) {
                            return A3(De, n.a, n.b, r);
                        }), Ke, r)), o = function(n) {
                            var r = A2(Ja, function(n) {
                                return A2(Ie, n, a);
                            }, n);
                            return A2(wo, v([
                                n.$ ? Oi("") : A2($o, "data-grid-key", n.a)
                            ]), v([
                                function() {
                                    if (r.$) return ji("");
                                    var n = r.a;
                                    return A2(zi, v([
                                        Oi("notification has-text-centered")
                                    ]), v([
                                        ji(n.a8)
                                    ]));
                                }()
                            ]));
                        }, c = n.H.b ? A2(mo, v([
                            Oi("table is-bordered is-narrow")
                        ]), v([
                            A2(yo, f, A2(_t, function(n) {
                                return A2(Ao, f, A2(_t, o, n));
                            }, go))
                        ])) : ji(""), s = n.H.b ? v([
                            A2(zi, f, f),
                            A2(Si, f, A2(_t, e, u))
                        ]) : f;
                        return {
                            aI: v([
                                (t = v([
                                    Li,
                                    A2(Ai, v([
                                        Oi("box")
                                    ]), v([
                                        A2(Ai, v([
                                            Oi("content")
                                        ]), s),
                                        c,
                                        A2(Ai, v([
                                            Oi("buttons")
                                        ]), v([
                                            A2(Qi, v([
                                                Oi("button is-primary"),
                                                Ki(lo)
                                            ]), v([
                                                ji("Generate")
                                            ]))
                                        ]))
                                    ]))
                                ]), A2(ho, v([
                                    Oi("section")
                                ]), v([
                                    A2(Ai, v([
                                        Oi("container")
                                    ]), t)
                                ])))
                            ]),
                            a7: Ci("Hex Crawl Sandbox")
                        };
                    }(e.a));
                default:
                    return A2(Mi, iu, function(n) {
                        var r;
                        return {
                            aI: v([
                                (r = v([
                                    Li,
                                    A2(Fi, v([
                                        Oi("title")
                                    ]), v([
                                        ji("Quick Chat-like Log")
                                    ])),
                                    A2(Ai, v([
                                        Oi("block")
                                    ]), v([
                                        A2(Ai, v([
                                            Oi("field has-addons")
                                        ]), v([
                                            A2(Ai, v([
                                                Oi("control")
                                            ]), v([
                                                A2(to, v([
                                                    Oi("input is-medium"),
                                                    so("text"),
                                                    bo(n.Z),
                                                    fo(Po)
                                                ]), f)
                                            ])),
                                            A2(Ai, v([
                                                Oi("control")
                                            ]), v([
                                                A2(Qi, v([
                                                    Oi("button is-primary is-medium"),
                                                    Ki(Wo)
                                                ]), v([
                                                    ji("Submit")
                                                ]))
                                            ]))
                                        ])),
                                        A2(Ai, v([
                                            Oi("field")
                                        ]), v([
                                            A2(zi, v([
                                                Oi("help")
                                            ]), v([
                                                ji("To roll dice, type like:"),
                                                A2(Qo, f, v([
                                                    ji("/r 3d6 1,2,3,-4")
                                                ]))
                                            ]))
                                        ]))
                                    ])),
                                    A2(Ai, v([
                                        Oi("box")
                                    ]), v([
                                        A2(Ai, v([
                                            Oi("content")
                                        ]), A2(_t, function(n) {
                                            return A2(zi, v([
                                                Oi("pt-1")
                                            ]), v([
                                                ji(n)
                                            ]));
                                        }, n.T))
                                    ]))
                                ]), A2(ho, v([
                                    Oi("section")
                                ]), v([
                                    A2(Ai, v([
                                        Oi("container")
                                    ]), r)
                                ])))
                            ]),
                            a7: Ci("Quick Chat")
                        };
                    }(e.a));
            }
        }
    }, Uu = Zu.bw, Yu = Zu.bx, Vu = function() {
        Vu.a(Uu(tr()));
    }, nr({
        aB: function(n) {
            return Vu.a = n, ur.addEventListener("popstate", Vu), 0 > ur.navigator.userAgent.indexOf("Trident") || ur.addEventListener("hashchange", Vu), F2(function(r, t) {
                if (!(t.ctrlKey || t.metaKey || t.shiftKey || t.button >= 1 || r.target || r.hasAttribute("download"))) {
                    t.preventDefault();
                    var e = r.href, u = tr(), a = Et(e).a;
                    n(Yu(a && u.aZ === a.aZ && u.aP === a.aP && u.aW.a === a.aW.a ? {
                        $: 0,
                        a: a
                    } : function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(e)));
                }
            });
        },
        bo: function(n) {
            return A3(Zu.bo, n, tr(), Vu);
        },
        bJ: Zu.bJ,
        bI: Zu.bI,
        bD: Zu.bD
    }));
    Ku = {
        Main: {
            init: hc(yi)(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? h(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, Ku) : n.Elm = Ku;
}($a0b4f895e1596b3b$exports);


const $56539e93f2f464a7$export$e20f46e0e4569dbd = [
    {
        "start": 1,
        "end": 2,
        "entry": {
            "event": "Wedding"
        }
    },
    {
        "start": 3,
        "end": 4,
        "entry": {
            "event": "Name-giving day celebrations"
        }
    },
    {
        "start": 5,
        "end": 6,
        "entry": {
            "event": "Public holiday"
        }
    },
    {
        "start": 7,
        "end": 8,
        "entry": {
            "event": "Procession"
        }
    },
    {
        "start": 9,
        "end": 10,
        "entry": {
            "event": "Harvest Festival"
        }
    },
    {
        "start": 11,
        "end": 12,
        "entry": {
            "event": "Festival celebrating a god"
        }
    },
    {
        "start": 13,
        "end": 14,
        "entry": {
            "event": "Celebration of a hero’s return"
        }
    },
    {
        "start": 15,
        "end": 16,
        "entry": {
            "event": "Market day"
        }
    },
    {
        "start": 17,
        "end": 18,
        "entry": {
            "event": "Religious rally"
        }
    },
    {
        "start": 19,
        "end": 20,
        "entry": {
            "event": "Official proclamation"
        }
    },
    {
        "start": 21,
        "end": 22,
        "entry": {
            "event": "Amnesty"
        }
    },
    {
        "start": 23,
        "end": 24,
        "entry": {
            "event": "Sudden storm / gale force winds"
        }
    },
    {
        "start": 25,
        "end": 26,
        "entry": {
            "event": "Election / Change of civic leader"
        }
    },
    {
        "start": 27,
        "end": 28,
        "entry": {
            "event": "Yearly local festival"
        }
    },
    {
        "start": 29,
        "end": 30,
        "entry": {
            "event": "Assassination"
        }
    },
    {
        "start": 31,
        "end": 32,
        "entry": {
            "event": "Performance of a play"
        }
    },
    {
        "start": 33,
        "end": 34,
        "entry": {
            "event": "Musical concert"
        }
    },
    {
        "start": 35,
        "end": 36,
        "entry": {
            "event": "Buskers performance"
        }
    },
    {
        "start": 37,
        "end": 38,
        "entry": {
            "event": "Orator / storyteller"
        }
    },
    {
        "start": 39,
        "end": 40,
        "entry": {
            "event": "Alefest"
        }
    },
    {
        "start": 41,
        "end": 42,
        "entry": {
            "event": "Warrior exhibition"
        }
    },
    {
        "start": 43,
        "end": 44,
        "entry": {
            "event": "Procession of royals"
        }
    },
    {
        "start": 45,
        "end": 46,
        "entry": {
            "event": "Museum exhibition"
        }
    },
    {
        "start": 47,
        "end": 48,
        "entry": {
            "event": "New building being opened"
        }
    },
    {
        "start": 49,
        "end": 50,
        "entry": {
            "event": "Large army passing through town"
        }
    },
    {
        "start": 51,
        "end": 52,
        "entry": {
            "event": "Gridlocked traffic"
        }
    },
    {
        "start": 53,
        "end": 54,
        "entry": {
            "event": "Monster invasion!"
        }
    },
    {
        "start": 55,
        "end": 56,
        "entry": {
            "event": "Conference of Wizards"
        }
    },
    {
        "start": 57,
        "end": 58,
        "entry": {
            "event": "Graduation ceremony"
        }
    },
    {
        "start": 59,
        "end": 60,
        "entry": {
            "event": "Traffic accident"
        }
    },
    {
        "start": 61,
        "end": 62,
        "entry": {
            "event": "Freakish weather event"
        }
    },
    {
        "start": 63,
        "end": 64,
        "entry": {
            "event": "Fire in Building"
        }
    },
    {
        "start": 65,
        "end": 66,
        "entry": {
            "event": "Notable local figure assassinated"
        }
    },
    {
        "start": 67,
        "end": 68,
        "entry": {
            "event": "Public duel"
        }
    },
    {
        "start": 69,
        "end": 70,
        "entry": {
            "event": "Large scale fire"
        }
    },
    {
        "start": 71,
        "end": 72,
        "entry": {
            "event": "Sinkhole opens"
        }
    },
    {
        "start": 73,
        "end": 74,
        "entry": {
            "event": "Local army returning after recent skirmish"
        }
    },
    {
        "start": 75,
        "end": 76,
        "entry": {
            "event": "Co-ordinated attack"
        }
    },
    {
        "start": 77,
        "end": 78,
        "entry": {
            "event": "Protest"
        }
    },
    {
        "start": 79,
        "end": 80,
        "entry": {
            "event": "Flood"
        }
    },
    {
        "start": 81,
        "end": 82,
        "entry": {
            "event": "Martial law enforced (Reason?)"
        }
    },
    {
        "start": 83,
        "end": 84,
        "entry": {
            "event": "Wild magic eruption"
        }
    },
    {
        "start": 85,
        "end": 86,
        "entry": {
            "event": "Military conscription"
        }
    },
    {
        "start": 87,
        "end": 88,
        "entry": {
            "event": "Revolution taking place (scale uncertain)"
        }
    },
    {
        "start": 89,
        "end": 90,
        "entry": {
            "event": "Public Execution"
        }
    },
    {
        "start": 91,
        "end": 92,
        "entry": {
            "event": "Storm"
        }
    },
    {
        "start": 93,
        "end": 94,
        "entry": {
            "event": "Plague"
        }
    },
    {
        "start": 95,
        "end": 96,
        "entry": {
            "event": "Earthquake"
        }
    },
    {
        "start": 97,
        "end": 98,
        "entry": {
            "event": "Dimensional disruption"
        }
    },
    {
        "start": 99,
        "end": 100,
        "entry": {
            "event": "Invading force"
        }
    }
];
const $56539e93f2f464a7$export$fe81d40a8678853c = [
    {
        "start": 1,
        "end": 2,
        "entry": {
            "event": "Landslide / Avalanche"
        }
    },
    {
        "start": 3,
        "end": 4,
        "entry": {
            "event": "Earthquake"
        }
    },
    {
        "start": 5,
        "end": 6,
        "entry": {
            "event": "Storm"
        }
    },
    {
        "start": 7,
        "end": 8,
        "entry": {
            "event": "Druid gathering"
        }
    },
    {
        "start": 9,
        "end": 10,
        "entry": {
            "event": "Religious pilgrimage"
        }
    },
    {
        "start": 11,
        "end": 12,
        "entry": {
            "event": "Army encamped"
        }
    },
    {
        "start": 13,
        "end": 14,
        "entry": {
            "event": "Sudden storm / gale force winds"
        }
    },
    {
        "start": 15,
        "end": 16,
        "entry": {
            "event": "Overturned cart"
        }
    },
    {
        "start": 17,
        "end": 18,
        "entry": {
            "event": "Flash flood"
        }
    },
    {
        "start": 19,
        "end": 20,
        "entry": {
            "event": "Forest Fire"
        }
    },
    {
        "start": 21,
        "end": 22,
        "entry": {
            "event": "Local humanoids having a festival"
        }
    },
    {
        "start": 23,
        "end": 24,
        "entry": {
            "event": "Solar eclipse"
        }
    },
    {
        "start": 25,
        "end": 26,
        "entry": {
            "event": "Hail (large hailstones?)"
        }
    },
    {
        "start": 27,
        "end": 28,
        "entry": {
            "event": "Hurricane"
        }
    },
    {
        "start": 29,
        "end": 30,
        "entry": {
            "event": "Tribal encounter"
        }
    },
    {
        "start": 31,
        "end": 32,
        "entry": {
            "event": "Animal stampede"
        }
    },
    {
        "start": 33,
        "end": 34,
        "entry": {
            "event": "Tree falls"
        }
    },
    {
        "start": 35,
        "end": 36,
        "entry": {
            "event": "Boulder falls"
        }
    },
    {
        "start": 37,
        "end": 38,
        "entry": {
            "event": "Unseasonable weather"
        }
    },
    {
        "start": 39,
        "end": 40,
        "entry": {
            "event": "Lightning strikes"
        }
    },
    {
        "start": 41,
        "end": 42,
        "entry": {
            "event": "Market"
        }
    },
    {
        "start": 43,
        "end": 44,
        "entry": {
            "event": "Hunting Party"
        }
    },
    {
        "start": 45,
        "end": 46,
        "entry": {
            "event": "Farmers harvesting crops"
        }
    },
    {
        "start": 47,
        "end": 48,
        "entry": {
            "event": "Cart passing"
        }
    },
    {
        "start": 49,
        "end": 50,
        "entry": {
            "event": "Refugees"
        }
    },
    {
        "start": 51,
        "end": 52,
        "entry": {
            "event": "Massed Animals"
        }
    },
    {
        "start": 53,
        "end": 54,
        "entry": {
            "event": "Toll demanded"
        }
    },
    {
        "start": 55,
        "end": 56,
        "entry": {
            "event": "Distressed NPC"
        }
    },
    {
        "start": 57,
        "end": 58,
        "entry": {
            "event": "Besieged settlement"
        }
    },
    {
        "start": 59,
        "end": 60,
        "entry": {
            "event": "Come across structure"
        }
    },
    {
        "start": 61,
        "end": 62,
        "entry": {
            "event": "Battle in progress"
        }
    },
    {
        "start": 63,
        "end": 64,
        "entry": {
            "event": "Beast / Monster carcass"
        }
    },
    {
        "start": 65,
        "end": 66,
        "entry": {
            "event": "Monster - easy encounter"
        }
    },
    {
        "start": 67,
        "end": 68,
        "entry": {
            "event": "Monster - easy encounter"
        }
    },
    {
        "start": 69,
        "end": 70,
        "entry": {
            "event": "Monster - medium encounter"
        }
    },
    {
        "start": 71,
        "end": 72,
        "entry": {
            "event": "Monster - medium encounter"
        }
    },
    {
        "start": 73,
        "end": 74,
        "entry": {
            "event": "Monster - hard encounter"
        }
    },
    {
        "start": 75,
        "end": 76,
        "entry": {
            "event": "Monster - deadly encounter"
        }
    },
    {
        "start": 77,
        "end": 78,
        "entry": {
            "event": "Volcanic eruption"
        }
    },
    {
        "start": 79,
        "end": 80,
        "entry": {
            "event": "Plague (insect / vermin)"
        }
    },
    {
        "start": 81,
        "end": 82,
        "entry": {
            "event": "Interdimensional Rift"
        }
    },
    {
        "start": 83,
        "end": 84,
        "entry": {
            "event": "Army going to war"
        }
    },
    {
        "start": 85,
        "end": 86,
        "entry": {
            "event": "Sinkhole Appears"
        }
    },
    {
        "start": 87,
        "end": 88,
        "entry": {
            "event": "Appearance of Tyrant in the area"
        }
    },
    {
        "start": 89,
        "end": 90,
        "entry": {
            "event": "Savage raiding party"
        }
    },
    {
        "start": 91,
        "end": 92,
        "entry": {
            "event": "Marauding monster attacking village"
        }
    },
    {
        "start": 93,
        "end": 94,
        "entry": {
            "event": "Undead awakening"
        }
    },
    {
        "start": 95,
        "end": 100,
        "entry": {
            "event": "Unmarked Settlement"
        }
    }
];


const $336b61757523412a$export$75315e8f908e65f1 = [
    {
        "start": 1,
        "end": 2,
        "entry": {
            "term1": "Cursed",
            "term2": "Sceptre of",
            "term3": "The Crimson",
            "term4": "Goddess"
        }
    },
    {
        "start": 3,
        "end": 4,
        "entry": {
            "term1": "Blessed",
            "term2": "Bowl of",
            "term3": "Desire",
            "term4": "Lightning"
        }
    },
    {
        "start": 5,
        "end": 6,
        "entry": {
            "term1": "Emerald",
            "term2": "Scroll of",
            "term3": "Enchanting",
            "term4": "Fire"
        }
    },
    {
        "start": 7,
        "end": 8,
        "entry": {
            "term1": "Illuminating",
            "term2": "Mirror of",
            "term3": "Merciful",
            "term4": "Fate"
        }
    },
    {
        "start": 9,
        "end": 10,
        "entry": {
            "term1": "Merciless",
            "term2": "Sword of",
            "term3": "Wrathful",
            "term4": "Rage"
        }
    },
    {
        "start": 11,
        "end": 12,
        "entry": {
            "term1": "All-seeing",
            "term2": "Stone of",
            "term3": "Pale",
            "term4": "Dawn"
        }
    },
    {
        "start": 13,
        "end": 14,
        "entry": {
            "term1": "Sheltering",
            "term2": "Casket of",
            "term3": "Endless",
            "term4": "Knowledge"
        }
    },
    {
        "start": 15,
        "end": 16,
        "entry": {
            "term1": "Dreaded",
            "term2": "Bell of",
            "term3": "Elemental",
            "term4": "Waters"
        }
    },
    {
        "start": 17,
        "end": 18,
        "entry": {
            "term1": "Immovable",
            "term2": "Chalice of",
            "term3": "Planar",
            "term4": "Music"
        }
    },
    {
        "start": 19,
        "end": 20,
        "entry": {
            "term1": "Mysterious",
            "term2": "Robe of",
            "term3": "Mighty",
            "term4": "Power"
        }
    },
    {
        "start": 21,
        "end": 22,
        "entry": {
            "term1": "Ever-changing",
            "term2": "Pipes of",
            "term3": "Joyous",
            "term4": "Peace"
        }
    },
    {
        "start": 23,
        "end": 24,
        "entry": {
            "term1": "Gilded",
            "term2": "Lamp of",
            "term3": "Exquisite",
            "term4": "Turmoil"
        }
    },
    {
        "start": 25,
        "end": 26,
        "entry": {
            "term1": "Many-coloured",
            "term2": "Idol of",
            "term3": "Cursed",
            "term4": "Illusion"
        }
    },
    {
        "start": 27,
        "end": 28,
        "entry": {
            "term1": "Heroic",
            "term2": "Tome of",
            "term3": "Opulent",
            "term4": "Morphing"
        }
    },
    {
        "start": 29,
        "end": 30,
        "entry": {
            "term1": "Wondrous",
            "term2": "Oil of",
            "term3": "Dimensional",
            "term4": "Secrets"
        }
    },
    {
        "start": 31,
        "end": 32,
        "entry": {
            "term1": "Boundless",
            "term2": "Drum of",
            "term3": "Temporal",
            "term4": "Navigation"
        }
    },
    {
        "start": 33,
        "end": 34,
        "entry": {
            "term1": "Depraved",
            "term2": "Chimes of",
            "term3": "Corrupt",
            "term4": "Fire"
        }
    },
    {
        "start": 35,
        "end": 36,
        "entry": {
            "term1": "Captivating",
            "term2": "Brazier of",
            "term3": "Omniscient",
            "term4": "Air"
        }
    },
    {
        "start": 37,
        "end": 38,
        "entry": {
            "term1": "Unusual",
            "term2": "Candelabra of",
            "term3": "Freezing",
            "term4": "Demon"
        }
    },
    {
        "start": 39,
        "end": 40,
        "entry": {
            "term1": "Dark",
            "term2": "Lute of",
            "term3": "Burning",
            "term4": "Frost"
        }
    },
    {
        "start": 41,
        "end": 42,
        "entry": {
            "term1": "Mystical",
            "term2": "Crown of",
            "term3": "Invisible",
            "term4": "Prophecy"
        }
    },
    {
        "start": 43,
        "end": 44,
        "entry": {
            "term1": "Eldritch",
            "term2": "Bottle of",
            "term3": "Distant",
            "term4": "Binding"
        }
    },
    {
        "start": 45,
        "end": 46,
        "entry": {
            "term1": "Elegant",
            "term2": "Rod of",
            "term3": "Planar",
            "term4": "Death"
        }
    },
    {
        "start": 47,
        "end": 48,
        "entry": {
            "term1": "Scintillating",
            "term2": "Prism of",
            "term3": "Unrelenting",
            "term4": "Laughter"
        }
    },
    {
        "start": 49,
        "end": 50,
        "entry": {
            "term1": "Stupendous",
            "term2": "Cauldron of",
            "term3": "Dark",
            "term4": "Purity"
        }
    },
    {
        "start": 51,
        "end": 52,
        "entry": {
            "term1": "Strange",
            "term2": "Crucible of",
            "term3": "Illuminating",
            "term4": "Alchemy"
        }
    },
    {
        "start": 53,
        "end": 54,
        "entry": {
            "term1": "Extravagant",
            "term2": "Decanter of",
            "term3": "Forbidden",
            "term4": "Insults"
        }
    },
    {
        "start": 55,
        "end": 56,
        "entry": {
            "term1": "Macabre",
            "term2": "Quill of",
            "term3": "Temporary",
            "term4": "Poison"
        }
    },
    {
        "start": 57,
        "end": 58,
        "entry": {
            "term1": "Imperial",
            "term2": "Horn of",
            "term3": "Decaying",
            "term4": "Healing"
        }
    },
    {
        "start": 59,
        "end": 60,
        "entry": {
            "term1": "Bizarre",
            "term2": "Globe of",
            "term3": "Crippling",
            "term4": "Heroism"
        }
    },
    {
        "start": 61,
        "end": 62,
        "entry": {
            "term1": "Jewelled",
            "term2": "Lens of",
            "term3": "Deafening",
            "term4": "Strength"
        }
    },
    {
        "start": 63,
        "end": 64,
        "entry": {
            "term1": "Superior",
            "term2": "Coffer of",
            "term3": "Blinding",
            "term4": "Form"
        }
    },
    {
        "start": 65,
        "end": 66,
        "entry": {
            "term1": "Animated",
            "term2": "Vase of",
            "term3": "Enlightening",
            "term4": "Mind-reading"
        }
    },
    {
        "start": 67,
        "end": 68,
        "entry": {
            "term1": "Chromatic",
            "term2": "Belt of",
            "term3": "Bolstering",
            "term4": "Longevity"
        }
    },
    {
        "start": 69,
        "end": 70,
        "entry": {
            "term1": "Illusory",
            "term2": "Cup of",
            "term3": "Benevolent",
            "term4": "Influence"
        }
    },
    {
        "start": 71,
        "end": 72,
        "entry": {
            "term1": "Angelic",
            "term2": "Shield of",
            "term3": "Glowing",
            "term4": "Evasion"
        }
    },
    {
        "start": 73,
        "end": 74,
        "entry": {
            "term1": "Metaphysical",
            "term2": "Armour of",
            "term3": "Resilient",
            "term4": "Protection"
        }
    },
    {
        "start": 75,
        "end": 76,
        "entry": {
            "term1": "Robust",
            "term2": "Elixir of",
            "term3": "Curious",
            "term4": "Resistance"
        }
    },
    {
        "start": 77,
        "end": 78,
        "entry": {
            "term1": "Simple",
            "term2": "Ring of",
            "term3": "Awe-inspiring",
            "term4": "Vision"
        }
    },
    {
        "start": 79,
        "end": 80,
        "entry": {
            "term1": "Divine",
            "term2": "Staff of",
            "term3": "Will-crushing",
            "term4": "Regeneration"
        }
    },
    {
        "start": 81,
        "end": 82,
        "entry": {
            "term1": "Ancient",
            "term2": "Wand of",
            "term3": "Telepathic",
            "term4": "Command"
        }
    },
    {
        "start": 83,
        "end": 84,
        "entry": {
            "term1": "Elven",
            "term2": "Arrow of",
            "term3": "Repelling",
            "term4": "Turning"
        }
    },
    {
        "start": 85,
        "end": 86,
        "entry": {
            "term1": "Dwarvish",
            "term2": "Bow of",
            "term3": "Absorbing",
            "term4": "Absorption"
        }
    },
    {
        "start": 87,
        "end": 88,
        "entry": {
            "term1": "Orcish",
            "term2": "Cloak of",
            "term3": "Unbreakable",
            "term4": "Adornment"
        }
    },
    {
        "start": 89,
        "end": 90,
        "entry": {
            "term1": "Dragonborn",
            "term2": "Helm of",
            "term3": "Dispelling",
            "term4": "Melody"
        }
    },
    {
        "start": 91,
        "end": 92,
        "entry": {
            "term1": "Tiefling",
            "term2": "Key of",
            "term3": "Frightening",
            "term4": "Pyrotechnics"
        }
    },
    {
        "start": 93,
        "end": 94,
        "entry": {
            "term1": "Drow",
            "term2": "Gem",
            "term3": "Burning",
            "term4": "Detection"
        }
    },
    {
        "start": 95,
        "end": 96,
        "entry": {
            "term1": "Shapeshifting",
            "term2": "Cube of",
            "term3": "Mischievous",
            "term4": "Paralysis"
        }
    },
    {
        "start": 97,
        "end": 98,
        "entry": {
            "term1": "Regenerating",
            "term2": "Talisman of",
            "term3": "Reflective",
            "term4": "Disruption"
        }
    },
    {
        "start": 99,
        "end": 100,
        "entry": {
            "term1": "Exquisite",
            "term2": "Device of",
            "term3": "Hypnotic",
            "term4": "Wizardry"
        }
    }
];


const $37d9c5575de5defb$export$cbc1416578dd3747 = [
    {
        "start": 1,
        "end": 4,
        "entry": {
            "problem": "Unjust killing",
            "quest": "Revenge"
        }
    },
    {
        "start": 5,
        "end": 8,
        "entry": {
            "problem": "Crime committed, criminal disappeared",
            "quest": "Apprehend / Bounty Hunt"
        }
    },
    {
        "start": 9,
        "end": 12,
        "entry": {
            "problem": "Item lost",
            "quest": "Retrieval"
        }
    },
    {
        "start": 13,
        "end": 16,
        "entry": {
            "problem": "Tyrant(s) threaten town / business / population (monster / humanoid)",
            "quest": "Repel / Sabotage / Deceive / Sabotage / Extort / Entrap"
        }
    },
    {
        "start": 17,
        "end": 20,
        "entry": {
            "problem": "Environmental disturbance / Strange Weather / Infestation / Plague",
            "quest": "Investigate / Solve"
        }
    },
    {
        "start": 21,
        "end": 24,
        "entry": {
            "problem": "Magical chaos / Curse",
            "quest": "Investigate / Lift curse / destroy magic"
        }
    },
    {
        "start": 25,
        "end": 28,
        "entry": {
            "problem": "Kidnapping / Hostage situation",
            "quest": "Rescue / Recover"
        }
    },
    {
        "start": 29,
        "end": 32,
        "entry": {
            "problem": "Adventurer left some time ago, but is lost",
            "quest": "Rescue"
        }
    },
    {
        "start": 33,
        "end": 36,
        "entry": {
            "problem": "Something is rumoured, but undiscovered",
            "quest": "Explore / Discover (Artefact, legendary place)"
        }
    },
    {
        "start": 37,
        "end": 40,
        "entry": {
            "problem": "Riches rumoured within secure, guarded place",
            "quest": "Loot"
        }
    },
    {
        "start": 41,
        "end": 44,
        "entry": {
            "problem": "Invasion",
            "quest": "Repel / Divert"
        }
    },
    {
        "start": 45,
        "end": 48,
        "entry": {
            "problem": "Person suspected of something",
            "quest": "Spy / Gather information"
        }
    },
    {
        "start": 49,
        "end": 52,
        "entry": {
            "problem": "Important item / message / person needs transporting",
            "quest": "Transport / smuggle / escort"
        }
    },
    {
        "start": 53,
        "end": 56,
        "entry": {
            "problem": "Nefarious / dangerous item being transported",
            "quest": "Waylay / Hijack"
        }
    },
    {
        "start": 57,
        "end": 60,
        "entry": {
            "problem": "Dangerous item exposed / up for grabs",
            "quest": "Find / Destroy"
        }
    },
    {
        "start": 61,
        "end": 64,
        "entry": {
            "problem": "Corrupt noble",
            "quest": "Investigate / Implicate / Incriminate / Expose"
        }
    },
    {
        "start": 65,
        "end": 68,
        "entry": {
            "problem": "Commodity shortage (goods, workforce)",
            "quest": "Transport supplies"
        }
    },
    {
        "start": 69,
        "end": 72,
        "entry": {
            "problem": "Mystery unresolved",
            "quest": "Research / Explore / Decode"
        }
    },
    {
        "start": 73,
        "end": 76,
        "entry": {
            "problem": "Adventurer thrown into life-threatening situation (environmental or otherwise)",
            "quest": "Survive"
        }
    },
    {
        "start": 77,
        "end": 80,
        "entry": {
            "problem": "Worthy creature’s life threatened (humanoid / animal / monster)",
            "quest": "Protect, eliminate threat"
        }
    },
    {
        "start": 81,
        "end": 84,
        "entry": {
            "problem": "Execution of innocent party planned",
            "quest": "Prevent"
        }
    },
    {
        "start": 85,
        "end": 88,
        "entry": {
            "problem": "Siege (anything from a small party of goblins surrounding a farmhouse to an army of Imperia Blades surrounding a city!)",
            "quest": "Break"
        }
    },
    {
        "start": 89,
        "end": 92,
        "entry": {
            "problem": "Huge battle about to erupt",
            "quest": "Negotiate / Prepare / Mediate / Participate"
        }
    },
    {
        "start": 93,
        "end": 96,
        "entry": {
            "problem": "Spiritually beneficial place rumoured",
            "quest": "Visit / Gain boon"
        }
    },
    {
        "start": 97,
        "end": 100,
        "entry": {
            "problem": "Foolish individual committed innocent blunder",
            "quest": "PC hired to conceal evidence / Return item / Placate"
        }
    }
];
const $37d9c5575de5defb$export$74fe797f33b01eca = [
    {
        "start": 1,
        "end": 3,
        "entry": "Notice board"
    },
    {
        "start": 4,
        "end": 6,
        "entry": "NPC"
    },
    {
        "start": 7,
        "end": 9,
        "entry": "Tavern rumour"
    },
    {
        "start": 10,
        "end": 13,
        "entry": "Stumble into situation"
    },
    {
        "start": 14,
        "end": 16,
        "entry": "Guild affiliate"
    },
    {
        "start": 17,
        "end": 19,
        "entry": "Fellow adventurer"
    },
    {
        "start": 20,
        "end": 22,
        "entry": "Mysterious scroll with info on it"
    },
    {
        "start": 23,
        "end": 25,
        "entry": "Hidden piece of paper inside a basic reward / purchase a pc makes"
    },
    {
        "start": 26,
        "end": 28,
        "entry": "Treasure map"
    },
    {
        "start": 29,
        "end": 31,
        "entry": "Found journal - Owner missing"
    },
    {
        "start": 32,
        "end": 34,
        "entry": "Partial map"
    },
    {
        "start": 35,
        "end": 37,
        "entry": "Inheritance - be it a place, an item, or a title."
    },
    {
        "start": 38,
        "end": 40,
        "entry": "Geas or Quest Spell"
    },
    {
        "start": 41,
        "end": 43,
        "entry": "Unholy visions"
    },
    {
        "start": 44,
        "end": 46,
        "entry": "A lost map or letter found"
    },
    {
        "start": 47,
        "end": 49,
        "entry": "Sent on mission by friend or relative"
    },
    {
        "start": 50,
        "end": 52,
        "entry": "A dream"
    },
    {
        "start": 53,
        "end": 55,
        "entry": "Local temple gives you the quest"
    },
    {
        "start": 56,
        "end": 58,
        "entry": "Rumour picked up at guard station"
    },
    {
        "start": 59,
        "end": 61,
        "entry": "Merchant’s Guild / merchants"
    },
    {
        "start": 62,
        "end": 64,
        "entry": "Noble family entrusts you"
    },
    {
        "start": 65,
        "end": 67,
        "entry": "Event sparks a memory"
    },
    {
        "start": 68,
        "end": 70,
        "entry": "Divine inspiration"
    },
    {
        "start": 71,
        "end": 73,
        "entry": "Overheard conversation"
    },
    {
        "start": 74,
        "end": 76,
        "entry": "Passing traveller"
    },
    {
        "start": 77,
        "end": 79,
        "entry": "Entrusted with delivering a parcel. Something compels you to peek inside!"
    },
    {
        "start": 80,
        "end": 83,
        "entry": "Herald makes proclamation in market square"
    },
    {
        "start": 84,
        "end": 87,
        "entry": "Orders from higher command, guild or society (from afar perhaps)"
    },
    {
        "start": 88,
        "end": 90,
        "entry": "Note on dead creature"
    },
    {
        "start": 91,
        "end": 93,
        "entry": "You awake with a map tattooed on you!"
    },
    {
        "start": 94,
        "end": 97,
        "entry": "Natural disaster reveals something"
    },
    {
        "start": 98,
        "end": 100,
        "entry": "A friend has died as a result of this situation, you must avenge!"
    }
];


const $c8c09cedc3d42941$export$eaf9d4c12671ce55 = [
    {
        "start": 1,
        "end": 1,
        "entry": {
            "verb": "abandon"
        }
    },
    {
        "start": 2,
        "end": 2,
        "entry": {
            "verb": "abolish"
        }
    },
    {
        "start": 3,
        "end": 3,
        "entry": {
            "verb": "abuse"
        }
    },
    {
        "start": 4,
        "end": 4,
        "entry": {
            "verb": "accuse"
        }
    },
    {
        "start": 5,
        "end": 5,
        "entry": {
            "verb": "address"
        }
    },
    {
        "start": 6,
        "end": 6,
        "entry": {
            "verb": "aggravate"
        }
    },
    {
        "start": 7,
        "end": 7,
        "entry": {
            "verb": "agitate"
        }
    },
    {
        "start": 8,
        "end": 8,
        "entry": {
            "verb": "aid"
        }
    },
    {
        "start": 9,
        "end": 9,
        "entry": {
            "verb": "aim"
        }
    },
    {
        "start": 10,
        "end": 10,
        "entry": {
            "verb": "alarm"
        }
    },
    {
        "start": 11,
        "end": 11,
        "entry": {
            "verb": "alert"
        }
    },
    {
        "start": 12,
        "end": 12,
        "entry": {
            "verb": "alter"
        }
    },
    {
        "start": 13,
        "end": 13,
        "entry": {
            "verb": "amaze"
        }
    },
    {
        "start": 14,
        "end": 14,
        "entry": {
            "verb": "ambush"
        }
    },
    {
        "start": 15,
        "end": 15,
        "entry": {
            "verb": "amuse"
        }
    },
    {
        "start": 16,
        "end": 16,
        "entry": {
            "verb": "annihilate"
        }
    },
    {
        "start": 17,
        "end": 17,
        "entry": {
            "verb": "annoy"
        }
    },
    {
        "start": 18,
        "end": 18,
        "entry": {
            "verb": "antagonize"
        }
    },
    {
        "start": 19,
        "end": 19,
        "entry": {
            "verb": "appeal"
        }
    },
    {
        "start": 20,
        "end": 20,
        "entry": {
            "verb": "applaud"
        }
    },
    {
        "start": 21,
        "end": 21,
        "entry": {
            "verb": "apprehend"
        }
    },
    {
        "start": 22,
        "end": 22,
        "entry": {
            "verb": "approach"
        }
    },
    {
        "start": 23,
        "end": 23,
        "entry": {
            "verb": "argue"
        }
    },
    {
        "start": 24,
        "end": 24,
        "entry": {
            "verb": "arise"
        }
    },
    {
        "start": 25,
        "end": 25,
        "entry": {
            "verb": "arouse"
        }
    },
    {
        "start": 26,
        "end": 26,
        "entry": {
            "verb": "arrange"
        }
    },
    {
        "start": 27,
        "end": 27,
        "entry": {
            "verb": "arrest"
        }
    },
    {
        "start": 28,
        "end": 28,
        "entry": {
            "verb": "ask"
        }
    },
    {
        "start": 29,
        "end": 29,
        "entry": {
            "verb": "assassinate"
        }
    },
    {
        "start": 30,
        "end": 30,
        "entry": {
            "verb": "assault"
        }
    },
    {
        "start": 31,
        "end": 31,
        "entry": {
            "verb": "assemble"
        }
    },
    {
        "start": 32,
        "end": 32,
        "entry": {
            "verb": "astonish"
        }
    },
    {
        "start": 33,
        "end": 33,
        "entry": {
            "verb": "attack"
        }
    },
    {
        "start": 34,
        "end": 34,
        "entry": {
            "verb": "attempt"
        }
    },
    {
        "start": 35,
        "end": 35,
        "entry": {
            "verb": "attend"
        }
    },
    {
        "start": 36,
        "end": 36,
        "entry": {
            "verb": "auction"
        }
    },
    {
        "start": 37,
        "end": 37,
        "entry": {
            "verb": "audition"
        }
    },
    {
        "start": 38,
        "end": 38,
        "entry": {
            "verb": "avenge"
        }
    },
    {
        "start": 39,
        "end": 39,
        "entry": {
            "verb": "avert"
        }
    },
    {
        "start": 40,
        "end": 40,
        "entry": {
            "verb": "babble"
        }
    },
    {
        "start": 41,
        "end": 41,
        "entry": {
            "verb": "badmouth"
        }
    },
    {
        "start": 42,
        "end": 42,
        "entry": {
            "verb": "bait"
        }
    },
    {
        "start": 43,
        "end": 43,
        "entry": {
            "verb": "ban"
        }
    },
    {
        "start": 44,
        "end": 44,
        "entry": {
            "verb": "banish"
        }
    },
    {
        "start": 45,
        "end": 45,
        "entry": {
            "verb": "baptize"
        }
    },
    {
        "start": 46,
        "end": 46,
        "entry": {
            "verb": "bargain"
        }
    },
    {
        "start": 47,
        "end": 47,
        "entry": {
            "verb": "bark"
        }
    },
    {
        "start": 48,
        "end": 48,
        "entry": {
            "verb": "barricade"
        }
    },
    {
        "start": 49,
        "end": 49,
        "entry": {
            "verb": "barter"
        }
    },
    {
        "start": 50,
        "end": 50,
        "entry": {
            "verb": "bash"
        }
    },
    {
        "start": 51,
        "end": 51,
        "entry": {
            "verb": "bawl"
        }
    },
    {
        "start": 52,
        "end": 52,
        "entry": {
            "verb": "beautify"
        }
    },
    {
        "start": 53,
        "end": 53,
        "entry": {
            "verb": "beckon"
        }
    },
    {
        "start": 54,
        "end": 54,
        "entry": {
            "verb": "befriend"
        }
    },
    {
        "start": 55,
        "end": 55,
        "entry": {
            "verb": "beg"
        }
    },
    {
        "start": 56,
        "end": 56,
        "entry": {
            "verb": "beguile"
        }
    },
    {
        "start": 57,
        "end": 57,
        "entry": {
            "verb": "belch"
        }
    },
    {
        "start": 58,
        "end": 58,
        "entry": {
            "verb": "belittle"
        }
    },
    {
        "start": 59,
        "end": 59,
        "entry": {
            "verb": "bellow"
        }
    },
    {
        "start": 60,
        "end": 60,
        "entry": {
            "verb": "bemoan"
        }
    },
    {
        "start": 61,
        "end": 61,
        "entry": {
            "verb": "bequeath"
        }
    },
    {
        "start": 62,
        "end": 62,
        "entry": {
            "verb": "berate"
        }
    },
    {
        "start": 63,
        "end": 63,
        "entry": {
            "verb": "besiege"
        }
    },
    {
        "start": 64,
        "end": 64,
        "entry": {
            "verb": "bestow"
        }
    },
    {
        "start": 65,
        "end": 65,
        "entry": {
            "verb": "bet"
        }
    },
    {
        "start": 66,
        "end": 66,
        "entry": {
            "verb": "betray"
        }
    },
    {
        "start": 67,
        "end": 67,
        "entry": {
            "verb": "bewilder"
        }
    },
    {
        "start": 68,
        "end": 68,
        "entry": {
            "verb": "bewitch"
        }
    },
    {
        "start": 69,
        "end": 69,
        "entry": {
            "verb": "bid"
        }
    },
    {
        "start": 70,
        "end": 70,
        "entry": {
            "verb": "bite"
        }
    },
    {
        "start": 71,
        "end": 71,
        "entry": {
            "verb": "blab"
        }
    },
    {
        "start": 72,
        "end": 72,
        "entry": {
            "verb": "blame"
        }
    },
    {
        "start": 73,
        "end": 73,
        "entry": {
            "verb": "blast"
        }
    },
    {
        "start": 74,
        "end": 74,
        "entry": {
            "verb": "bleed"
        }
    },
    {
        "start": 75,
        "end": 75,
        "entry": {
            "verb": "bless"
        }
    },
    {
        "start": 76,
        "end": 76,
        "entry": {
            "verb": "blunder"
        }
    },
    {
        "start": 77,
        "end": 77,
        "entry": {
            "verb": "blurt"
        }
    },
    {
        "start": 78,
        "end": 78,
        "entry": {
            "verb": "boast"
        }
    },
    {
        "start": 79,
        "end": 79,
        "entry": {
            "verb": "bother"
        }
    },
    {
        "start": 80,
        "end": 80,
        "entry": {
            "verb": "bow"
        }
    },
    {
        "start": 81,
        "end": 81,
        "entry": {
            "verb": "brag"
        }
    },
    {
        "start": 82,
        "end": 82,
        "entry": {
            "verb": "break"
        }
    },
    {
        "start": 83,
        "end": 83,
        "entry": {
            "verb": "bribe"
        }
    },
    {
        "start": 84,
        "end": 84,
        "entry": {
            "verb": "broadcast"
        }
    },
    {
        "start": 85,
        "end": 85,
        "entry": {
            "verb": "build"
        }
    },
    {
        "start": 86,
        "end": 86,
        "entry": {
            "verb": "capture"
        }
    },
    {
        "start": 87,
        "end": 87,
        "entry": {
            "verb": "careen"
        }
    },
    {
        "start": 88,
        "end": 88,
        "entry": {
            "verb": "caress"
        }
    },
    {
        "start": 89,
        "end": 89,
        "entry": {
            "verb": "carry"
        }
    },
    {
        "start": 90,
        "end": 90,
        "entry": {
            "verb": "carve"
        }
    },
    {
        "start": 91,
        "end": 91,
        "entry": {
            "verb": "catch"
        }
    },
    {
        "start": 92,
        "end": 92,
        "entry": {
            "verb": "celebrate"
        }
    },
    {
        "start": 93,
        "end": 93,
        "entry": {
            "verb": "challenge"
        }
    },
    {
        "start": 94,
        "end": 94,
        "entry": {
            "verb": "charm"
        }
    },
    {
        "start": 95,
        "end": 95,
        "entry": {
            "verb": "chase"
        }
    },
    {
        "start": 96,
        "end": 96,
        "entry": {
            "verb": "cheat"
        }
    },
    {
        "start": 97,
        "end": 97,
        "entry": {
            "verb": "choke"
        }
    },
    {
        "start": 98,
        "end": 98,
        "entry": {
            "verb": "claim"
        }
    },
    {
        "start": 99,
        "end": 99,
        "entry": {
            "verb": "climb"
        }
    },
    {
        "start": 100,
        "end": 100,
        "entry": {
            "verb": "collaborate"
        }
    },
    {
        "start": 101,
        "end": 101,
        "entry": {
            "verb": "collapse"
        }
    },
    {
        "start": 102,
        "end": 102,
        "entry": {
            "verb": "collide"
        }
    },
    {
        "start": 103,
        "end": 103,
        "entry": {
            "verb": "command"
        }
    },
    {
        "start": 104,
        "end": 104,
        "entry": {
            "verb": "complain"
        }
    },
    {
        "start": 105,
        "end": 105,
        "entry": {
            "verb": "compliment"
        }
    },
    {
        "start": 106,
        "end": 106,
        "entry": {
            "verb": "conceal"
        }
    },
    {
        "start": 107,
        "end": 107,
        "entry": {
            "verb": "concoct"
        }
    },
    {
        "start": 108,
        "end": 108,
        "entry": {
            "verb": "condemn"
        }
    },
    {
        "start": 109,
        "end": 109,
        "entry": {
            "verb": "confiscate"
        }
    },
    {
        "start": 110,
        "end": 110,
        "entry": {
            "verb": "conflict"
        }
    },
    {
        "start": 111,
        "end": 111,
        "entry": {
            "verb": "confront"
        }
    },
    {
        "start": 112,
        "end": 112,
        "entry": {
            "verb": "confuse"
        }
    },
    {
        "start": 113,
        "end": 113,
        "entry": {
            "verb": "congratulate"
        }
    },
    {
        "start": 114,
        "end": 114,
        "entry": {
            "verb": "congregate"
        }
    },
    {
        "start": 115,
        "end": 115,
        "entry": {
            "verb": "conjure"
        }
    },
    {
        "start": 116,
        "end": 116,
        "entry": {
            "verb": "consecrate"
        }
    },
    {
        "start": 117,
        "end": 117,
        "entry": {
            "verb": "consider"
        }
    },
    {
        "start": 118,
        "end": 118,
        "entry": {
            "verb": "construct"
        }
    },
    {
        "start": 119,
        "end": 119,
        "entry": {
            "verb": "contact"
        }
    },
    {
        "start": 120,
        "end": 120,
        "entry": {
            "verb": "contaminate"
        }
    },
    {
        "start": 121,
        "end": 121,
        "entry": {
            "verb": "contest"
        }
    },
    {
        "start": 122,
        "end": 122,
        "entry": {
            "verb": "cook"
        }
    },
    {
        "start": 123,
        "end": 123,
        "entry": {
            "verb": "corner"
        }
    },
    {
        "start": 124,
        "end": 124,
        "entry": {
            "verb": "corrupt"
        }
    },
    {
        "start": 125,
        "end": 125,
        "entry": {
            "verb": "cremate"
        }
    },
    {
        "start": 126,
        "end": 126,
        "entry": {
            "verb": "crowd"
        }
    },
    {
        "start": 127,
        "end": 127,
        "entry": {
            "verb": "crown"
        }
    },
    {
        "start": 128,
        "end": 128,
        "entry": {
            "verb": "customize"
        }
    },
    {
        "start": 129,
        "end": 129,
        "entry": {
            "verb": "damage"
        }
    },
    {
        "start": 130,
        "end": 130,
        "entry": {
            "verb": "dance"
        }
    },
    {
        "start": 131,
        "end": 131,
        "entry": {
            "verb": "dare"
        }
    },
    {
        "start": 132,
        "end": 132,
        "entry": {
            "verb": "dash"
        }
    },
    {
        "start": 133,
        "end": 133,
        "entry": {
            "verb": "dazzle"
        }
    },
    {
        "start": 134,
        "end": 134,
        "entry": {
            "verb": "deal"
        }
    },
    {
        "start": 135,
        "end": 135,
        "entry": {
            "verb": "debate"
        }
    },
    {
        "start": 136,
        "end": 136,
        "entry": {
            "verb": "decay"
        }
    },
    {
        "start": 137,
        "end": 137,
        "entry": {
            "verb": "deceive"
        }
    },
    {
        "start": 138,
        "end": 138,
        "entry": {
            "verb": "declare"
        }
    },
    {
        "start": 139,
        "end": 139,
        "entry": {
            "verb": "decline"
        }
    },
    {
        "start": 140,
        "end": 140,
        "entry": {
            "verb": "decompose"
        }
    },
    {
        "start": 141,
        "end": 141,
        "entry": {
            "verb": "decorate"
        }
    },
    {
        "start": 142,
        "end": 142,
        "entry": {
            "verb": "decree"
        }
    },
    {
        "start": 143,
        "end": 143,
        "entry": {
            "verb": "dedicate"
        }
    },
    {
        "start": 144,
        "end": 144,
        "entry": {
            "verb": "deduce"
        }
    },
    {
        "start": 145,
        "end": 145,
        "entry": {
            "verb": "deface"
        }
    },
    {
        "start": 146,
        "end": 146,
        "entry": {
            "verb": "defeat"
        }
    },
    {
        "start": 147,
        "end": 147,
        "entry": {
            "verb": "defend"
        }
    },
    {
        "start": 148,
        "end": 148,
        "entry": {
            "verb": "defuse"
        }
    },
    {
        "start": 149,
        "end": 149,
        "entry": {
            "verb": "deliver"
        }
    },
    {
        "start": 150,
        "end": 150,
        "entry": {
            "verb": "demand"
        }
    },
    {
        "start": 151,
        "end": 151,
        "entry": {
            "verb": "demolish"
        }
    },
    {
        "start": 152,
        "end": 152,
        "entry": {
            "verb": "denounce"
        }
    },
    {
        "start": 153,
        "end": 153,
        "entry": {
            "verb": "deride"
        }
    },
    {
        "start": 154,
        "end": 154,
        "entry": {
            "verb": "despair"
        }
    },
    {
        "start": 155,
        "end": 155,
        "entry": {
            "verb": "destroy"
        }
    },
    {
        "start": 156,
        "end": 156,
        "entry": {
            "verb": "devour"
        }
    },
    {
        "start": 157,
        "end": 157,
        "entry": {
            "verb": "dig"
        }
    },
    {
        "start": 158,
        "end": 158,
        "entry": {
            "verb": "disappear"
        }
    },
    {
        "start": 159,
        "end": 159,
        "entry": {
            "verb": "disarm"
        }
    },
    {
        "start": 160,
        "end": 160,
        "entry": {
            "verb": "discipline"
        }
    },
    {
        "start": 161,
        "end": 161,
        "entry": {
            "verb": "discover"
        }
    },
    {
        "start": 162,
        "end": 162,
        "entry": {
            "verb": "discriminate"
        }
    },
    {
        "start": 163,
        "end": 163,
        "entry": {
            "verb": "discuss"
        }
    },
    {
        "start": 164,
        "end": 164,
        "entry": {
            "verb": "disgrace"
        }
    },
    {
        "start": 165,
        "end": 165,
        "entry": {
            "verb": "disguise"
        }
    },
    {
        "start": 166,
        "end": 166,
        "entry": {
            "verb": "disgust"
        }
    },
    {
        "start": 167,
        "end": 167,
        "entry": {
            "verb": "dishonor"
        }
    },
    {
        "start": 168,
        "end": 168,
        "entry": {
            "verb": "dismount"
        }
    },
    {
        "start": 169,
        "end": 169,
        "entry": {
            "verb": "dispel"
        }
    },
    {
        "start": 170,
        "end": 170,
        "entry": {
            "verb": "disperse"
        }
    },
    {
        "start": 171,
        "end": 171,
        "entry": {
            "verb": "display"
        }
    },
    {
        "start": 172,
        "end": 172,
        "entry": {
            "verb": "displease"
        }
    },
    {
        "start": 173,
        "end": 173,
        "entry": {
            "verb": "dispute"
        }
    },
    {
        "start": 174,
        "end": 174,
        "entry": {
            "verb": "disrespect"
        }
    },
    {
        "start": 175,
        "end": 175,
        "entry": {
            "verb": "disrupt"
        }
    },
    {
        "start": 176,
        "end": 176,
        "entry": {
            "verb": "distill"
        }
    },
    {
        "start": 177,
        "end": 177,
        "entry": {
            "verb": "distress"
        }
    },
    {
        "start": 178,
        "end": 178,
        "entry": {
            "verb": "disturb"
        }
    },
    {
        "start": 179,
        "end": 179,
        "entry": {
            "verb": "divert"
        }
    },
    {
        "start": 180,
        "end": 180,
        "entry": {
            "verb": "dodge"
        }
    },
    {
        "start": 181,
        "end": 181,
        "entry": {
            "verb": "drag"
        }
    },
    {
        "start": 182,
        "end": 182,
        "entry": {
            "verb": "dress"
        }
    },
    {
        "start": 183,
        "end": 183,
        "entry": {
            "verb": "drink"
        }
    },
    {
        "start": 184,
        "end": 184,
        "entry": {
            "verb": "drop"
        }
    },
    {
        "start": 185,
        "end": 185,
        "entry": {
            "verb": "drown"
        }
    },
    {
        "start": 186,
        "end": 186,
        "entry": {
            "verb": "drum"
        }
    },
    {
        "start": 187,
        "end": 187,
        "entry": {
            "verb": "dump"
        }
    },
    {
        "start": 188,
        "end": 188,
        "entry": {
            "verb": "dupe"
        }
    },
    {
        "start": 189,
        "end": 189,
        "entry": {
            "verb": "duplicate"
        }
    },
    {
        "start": 190,
        "end": 190,
        "entry": {
            "verb": "earn"
        }
    },
    {
        "start": 191,
        "end": 191,
        "entry": {
            "verb": "eat"
        }
    },
    {
        "start": 192,
        "end": 192,
        "entry": {
            "verb": "elude"
        }
    },
    {
        "start": 193,
        "end": 193,
        "entry": {
            "verb": "employ"
        }
    },
    {
        "start": 194,
        "end": 194,
        "entry": {
            "verb": "enchant"
        }
    },
    {
        "start": 195,
        "end": 195,
        "entry": {
            "verb": "end"
        }
    },
    {
        "start": 196,
        "end": 196,
        "entry": {
            "verb": "endanger"
        }
    },
    {
        "start": 197,
        "end": 197,
        "entry": {
            "verb": "endear"
        }
    },
    {
        "start": 198,
        "end": 198,
        "entry": {
            "verb": "endorse"
        }
    },
    {
        "start": 199,
        "end": 199,
        "entry": {
            "verb": "enforce"
        }
    },
    {
        "start": 200,
        "end": 200,
        "entry": {
            "verb": "engage"
        }
    },
    {
        "start": 201,
        "end": 201,
        "entry": {
            "verb": "engineer"
        }
    },
    {
        "start": 202,
        "end": 202,
        "entry": {
            "verb": "enjoy"
        }
    },
    {
        "start": 203,
        "end": 203,
        "entry": {
            "verb": "enlarge"
        }
    },
    {
        "start": 204,
        "end": 204,
        "entry": {
            "verb": "enlighten"
        }
    },
    {
        "start": 205,
        "end": 205,
        "entry": {
            "verb": "enlist"
        }
    },
    {
        "start": 206,
        "end": 206,
        "entry": {
            "verb": "enquire"
        }
    },
    {
        "start": 207,
        "end": 207,
        "entry": {
            "verb": "enrage"
        }
    },
    {
        "start": 208,
        "end": 208,
        "entry": {
            "verb": "enrich"
        }
    },
    {
        "start": 209,
        "end": 209,
        "entry": {
            "verb": "enroll"
        }
    },
    {
        "start": 210,
        "end": 210,
        "entry": {
            "verb": "enshrine"
        }
    },
    {
        "start": 211,
        "end": 211,
        "entry": {
            "verb": "ensnare"
        }
    },
    {
        "start": 212,
        "end": 212,
        "entry": {
            "verb": "entangle"
        }
    },
    {
        "start": 213,
        "end": 213,
        "entry": {
            "verb": "enter"
        }
    },
    {
        "start": 214,
        "end": 214,
        "entry": {
            "verb": "entertain"
        }
    },
    {
        "start": 215,
        "end": 215,
        "entry": {
            "verb": "entice"
        }
    },
    {
        "start": 216,
        "end": 216,
        "entry": {
            "verb": "erect"
        }
    },
    {
        "start": 217,
        "end": 217,
        "entry": {
            "verb": "escape"
        }
    },
    {
        "start": 218,
        "end": 218,
        "entry": {
            "verb": "escort"
        }
    },
    {
        "start": 219,
        "end": 219,
        "entry": {
            "verb": "evacuate"
        }
    },
    {
        "start": 220,
        "end": 220,
        "entry": {
            "verb": "evade"
        }
    },
    {
        "start": 221,
        "end": 221,
        "entry": {
            "verb": "evict"
        }
    },
    {
        "start": 222,
        "end": 222,
        "entry": {
            "verb": "exaggerate"
        }
    },
    {
        "start": 223,
        "end": 223,
        "entry": {
            "verb": "examine"
        }
    },
    {
        "start": 224,
        "end": 224,
        "entry": {
            "verb": "excavate"
        }
    },
    {
        "start": 225,
        "end": 225,
        "entry": {
            "verb": "exchange"
        }
    },
    {
        "start": 226,
        "end": 226,
        "entry": {
            "verb": "exclaim"
        }
    },
    {
        "start": 227,
        "end": 227,
        "entry": {
            "verb": "exclude"
        }
    },
    {
        "start": 228,
        "end": 228,
        "entry": {
            "verb": "execute"
        }
    },
    {
        "start": 229,
        "end": 229,
        "entry": {
            "verb": "exhibit"
        }
    },
    {
        "start": 230,
        "end": 230,
        "entry": {
            "verb": "experiment"
        }
    },
    {
        "start": 231,
        "end": 231,
        "entry": {
            "verb": "explode"
        }
    },
    {
        "start": 232,
        "end": 232,
        "entry": {
            "verb": "expose"
        }
    },
    {
        "start": 233,
        "end": 233,
        "entry": {
            "verb": "faint"
        }
    },
    {
        "start": 234,
        "end": 234,
        "entry": {
            "verb": "fake"
        }
    },
    {
        "start": 235,
        "end": 235,
        "entry": {
            "verb": "fall"
        }
    },
    {
        "start": 236,
        "end": 236,
        "entry": {
            "verb": "falsify"
        }
    },
    {
        "start": 237,
        "end": 237,
        "entry": {
            "verb": "fashion"
        }
    },
    {
        "start": 238,
        "end": 238,
        "entry": {
            "verb": "flaunt"
        }
    },
    {
        "start": 239,
        "end": 239,
        "entry": {
            "verb": "flee"
        }
    },
    {
        "start": 240,
        "end": 240,
        "entry": {
            "verb": "fling"
        }
    },
    {
        "start": 241,
        "end": 241,
        "entry": {
            "verb": "flirt"
        }
    },
    {
        "start": 242,
        "end": 242,
        "entry": {
            "verb": "follow"
        }
    },
    {
        "start": 243,
        "end": 243,
        "entry": {
            "verb": "force"
        }
    },
    {
        "start": 244,
        "end": 244,
        "entry": {
            "verb": "foresee"
        }
    },
    {
        "start": 245,
        "end": 245,
        "entry": {
            "verb": "foretell"
        }
    },
    {
        "start": 246,
        "end": 246,
        "entry": {
            "verb": "forge"
        }
    },
    {
        "start": 247,
        "end": 247,
        "entry": {
            "verb": "forgive"
        }
    },
    {
        "start": 248,
        "end": 248,
        "entry": {
            "verb": "fracture"
        }
    },
    {
        "start": 249,
        "end": 249,
        "entry": {
            "verb": "frame"
        }
    },
    {
        "start": 250,
        "end": 250,
        "entry": {
            "verb": "free"
        }
    },
    {
        "start": 251,
        "end": 251,
        "entry": {
            "verb": "freeze"
        }
    },
    {
        "start": 252,
        "end": 252,
        "entry": {
            "verb": "fret"
        }
    },
    {
        "start": 253,
        "end": 253,
        "entry": {
            "verb": "frighten"
        }
    },
    {
        "start": 254,
        "end": 254,
        "entry": {
            "verb": "frustrate"
        }
    },
    {
        "start": 255,
        "end": 255,
        "entry": {
            "verb": "fumble"
        }
    },
    {
        "start": 256,
        "end": 256,
        "entry": {
            "verb": "fund"
        }
    },
    {
        "start": 257,
        "end": 257,
        "entry": {
            "verb": "fuss"
        }
    },
    {
        "start": 258,
        "end": 258,
        "entry": {
            "verb": "gallop"
        }
    },
    {
        "start": 259,
        "end": 259,
        "entry": {
            "verb": "gamble"
        }
    },
    {
        "start": 260,
        "end": 260,
        "entry": {
            "verb": "gather"
        }
    },
    {
        "start": 261,
        "end": 261,
        "entry": {
            "verb": "gaze"
        }
    },
    {
        "start": 262,
        "end": 262,
        "entry": {
            "verb": "gesture"
        }
    },
    {
        "start": 263,
        "end": 263,
        "entry": {
            "verb": "gift"
        }
    },
    {
        "start": 264,
        "end": 264,
        "entry": {
            "verb": "giggle"
        }
    },
    {
        "start": 265,
        "end": 265,
        "entry": {
            "verb": "give"
        }
    },
    {
        "start": 266,
        "end": 266,
        "entry": {
            "verb": "glare"
        }
    },
    {
        "start": 267,
        "end": 267,
        "entry": {
            "verb": "gleam"
        }
    },
    {
        "start": 268,
        "end": 268,
        "entry": {
            "verb": "glimpse"
        }
    },
    {
        "start": 269,
        "end": 269,
        "entry": {
            "verb": "goad"
        }
    },
    {
        "start": 270,
        "end": 270,
        "entry": {
            "verb": "gob"
        }
    },
    {
        "start": 271,
        "end": 271,
        "entry": {
            "verb": "goggle"
        }
    },
    {
        "start": 272,
        "end": 272,
        "entry": {
            "verb": "gossip"
        }
    },
    {
        "start": 273,
        "end": 273,
        "entry": {
            "verb": "grab"
        }
    },
    {
        "start": 274,
        "end": 274,
        "entry": {
            "verb": "grapple"
        }
    },
    {
        "start": 275,
        "end": 275,
        "entry": {
            "verb": "grieve"
        }
    },
    {
        "start": 276,
        "end": 276,
        "entry": {
            "verb": "guard"
        }
    },
    {
        "start": 277,
        "end": 277,
        "entry": {
            "verb": "hamper"
        }
    },
    {
        "start": 278,
        "end": 278,
        "entry": {
            "verb": "harass"
        }
    },
    {
        "start": 279,
        "end": 279,
        "entry": {
            "verb": "harm"
        }
    },
    {
        "start": 280,
        "end": 280,
        "entry": {
            "verb": "help"
        }
    },
    {
        "start": 281,
        "end": 281,
        "entry": {
            "verb": "hide"
        }
    },
    {
        "start": 282,
        "end": 282,
        "entry": {
            "verb": "hit"
        }
    },
    {
        "start": 283,
        "end": 283,
        "entry": {
            "verb": "hold"
        }
    },
    {
        "start": 284,
        "end": 284,
        "entry": {
            "verb": "humiliate"
        }
    },
    {
        "start": 285,
        "end": 285,
        "entry": {
            "verb": "hurry"
        }
    },
    {
        "start": 286,
        "end": 286,
        "entry": {
            "verb": "hurtle"
        }
    },
    {
        "start": 287,
        "end": 287,
        "entry": {
            "verb": "ignite"
        }
    },
    {
        "start": 288,
        "end": 288,
        "entry": {
            "verb": "impede"
        }
    },
    {
        "start": 289,
        "end": 289,
        "entry": {
            "verb": "implore"
        }
    },
    {
        "start": 290,
        "end": 290,
        "entry": {
            "verb": "imprison"
        }
    },
    {
        "start": 291,
        "end": 291,
        "entry": {
            "verb": "infect"
        }
    },
    {
        "start": 292,
        "end": 292,
        "entry": {
            "verb": "infest"
        }
    },
    {
        "start": 293,
        "end": 293,
        "entry": {
            "verb": "inflame"
        }
    },
    {
        "start": 294,
        "end": 294,
        "entry": {
            "verb": "inflict"
        }
    },
    {
        "start": 295,
        "end": 295,
        "entry": {
            "verb": "inform"
        }
    },
    {
        "start": 296,
        "end": 296,
        "entry": {
            "verb": "infringe"
        }
    },
    {
        "start": 297,
        "end": 297,
        "entry": {
            "verb": "infuriate"
        }
    },
    {
        "start": 298,
        "end": 298,
        "entry": {
            "verb": "injure"
        }
    },
    {
        "start": 299,
        "end": 299,
        "entry": {
            "verb": "inspect"
        }
    },
    {
        "start": 300,
        "end": 300,
        "entry": {
            "verb": "inspire"
        }
    },
    {
        "start": 301,
        "end": 301,
        "entry": {
            "verb": "instigate"
        }
    },
    {
        "start": 302,
        "end": 302,
        "entry": {
            "verb": "insult"
        }
    },
    {
        "start": 303,
        "end": 303,
        "entry": {
            "verb": "interfere"
        }
    },
    {
        "start": 304,
        "end": 304,
        "entry": {
            "verb": "interrogate"
        }
    },
    {
        "start": 305,
        "end": 305,
        "entry": {
            "verb": "intimidate"
        }
    },
    {
        "start": 306,
        "end": 306,
        "entry": {
            "verb": "intoxicate"
        }
    },
    {
        "start": 307,
        "end": 307,
        "entry": {
            "verb": "investigate"
        }
    },
    {
        "start": 308,
        "end": 308,
        "entry": {
            "verb": "invite"
        }
    },
    {
        "start": 309,
        "end": 309,
        "entry": {
            "verb": "involve"
        }
    },
    {
        "start": 310,
        "end": 310,
        "entry": {
            "verb": "irritate"
        }
    },
    {
        "start": 311,
        "end": 311,
        "entry": {
            "verb": "jaywalk"
        }
    },
    {
        "start": 312,
        "end": 312,
        "entry": {
            "verb": "jeer"
        }
    },
    {
        "start": 313,
        "end": 313,
        "entry": {
            "verb": "joke"
        }
    },
    {
        "start": 314,
        "end": 314,
        "entry": {
            "verb": "jostle"
        }
    },
    {
        "start": 315,
        "end": 315,
        "entry": {
            "verb": "kick"
        }
    },
    {
        "start": 316,
        "end": 316,
        "entry": {
            "verb": "kill"
        }
    },
    {
        "start": 317,
        "end": 317,
        "entry": {
            "verb": "kiss"
        }
    },
    {
        "start": 318,
        "end": 318,
        "entry": {
            "verb": "lament"
        }
    },
    {
        "start": 319,
        "end": 319,
        "entry": {
            "verb": "laugh"
        }
    },
    {
        "start": 320,
        "end": 320,
        "entry": {
            "verb": "leap"
        }
    },
    {
        "start": 321,
        "end": 321,
        "entry": {
            "verb": "lecture"
        }
    },
    {
        "start": 322,
        "end": 322,
        "entry": {
            "verb": "leer"
        }
    },
    {
        "start": 323,
        "end": 323,
        "entry": {
            "verb": "look"
        }
    },
    {
        "start": 324,
        "end": 324,
        "entry": {
            "verb": "loot"
        }
    },
    {
        "start": 325,
        "end": 325,
        "entry": {
            "verb": "lose"
        }
    },
    {
        "start": 326,
        "end": 326,
        "entry": {
            "verb": "love"
        }
    },
    {
        "start": 327,
        "end": 327,
        "entry": {
            "verb": "lunge"
        }
    },
    {
        "start": 328,
        "end": 328,
        "entry": {
            "verb": "lurk"
        }
    },
    {
        "start": 329,
        "end": 329,
        "entry": {
            "verb": "maim"
        }
    },
    {
        "start": 330,
        "end": 330,
        "entry": {
            "verb": "manhandle"
        }
    },
    {
        "start": 331,
        "end": 331,
        "entry": {
            "verb": "march"
        }
    },
    {
        "start": 332,
        "end": 332,
        "entry": {
            "verb": "market"
        }
    },
    {
        "start": 333,
        "end": 333,
        "entry": {
            "verb": "massacre"
        }
    },
    {
        "start": 334,
        "end": 334,
        "entry": {
            "verb": "meddle"
        }
    },
    {
        "start": 335,
        "end": 335,
        "entry": {
            "verb": "mesmerize"
        }
    },
    {
        "start": 336,
        "end": 336,
        "entry": {
            "verb": "mimic"
        }
    },
    {
        "start": 337,
        "end": 337,
        "entry": {
            "verb": "misspell"
        }
    },
    {
        "start": 338,
        "end": 338,
        "entry": {
            "verb": "mob"
        }
    },
    {
        "start": 339,
        "end": 339,
        "entry": {
            "verb": "mock"
        }
    },
    {
        "start": 340,
        "end": 340,
        "entry": {
            "verb": "murder"
        }
    },
    {
        "start": 341,
        "end": 341,
        "entry": {
            "verb": "mutate"
        }
    },
    {
        "start": 342,
        "end": 342,
        "entry": {
            "verb": "mutilate"
        }
    },
    {
        "start": 343,
        "end": 343,
        "entry": {
            "verb": "nag"
        }
    },
    {
        "start": 344,
        "end": 344,
        "entry": {
            "verb": "narrate"
        }
    },
    {
        "start": 345,
        "end": 345,
        "entry": {
            "verb": "near"
        }
    },
    {
        "start": 346,
        "end": 346,
        "entry": {
            "verb": "notify"
        }
    },
    {
        "start": 347,
        "end": 347,
        "entry": {
            "verb": "obscure"
        }
    },
    {
        "start": 348,
        "end": 348,
        "entry": {
            "verb": "observe"
        }
    },
    {
        "start": 349,
        "end": 349,
        "entry": {
            "verb": "obstruct"
        }
    },
    {
        "start": 350,
        "end": 350,
        "entry": {
            "verb": "offend"
        }
    },
    {
        "start": 351,
        "end": 351,
        "entry": {
            "verb": "oppress"
        }
    },
    {
        "start": 352,
        "end": 352,
        "entry": {
            "verb": "order"
        }
    },
    {
        "start": 353,
        "end": 353,
        "entry": {
            "verb": "overhear"
        }
    },
    {
        "start": 354,
        "end": 354,
        "entry": {
            "verb": "overpower"
        }
    },
    {
        "start": 355,
        "end": 355,
        "entry": {
            "verb": "overturn"
        }
    },
    {
        "start": 356,
        "end": 356,
        "entry": {
            "verb": "parade"
        }
    },
    {
        "start": 357,
        "end": 357,
        "entry": {
            "verb": "parley"
        }
    },
    {
        "start": 358,
        "end": 358,
        "entry": {
            "verb": "patrol"
        }
    },
    {
        "start": 359,
        "end": 359,
        "entry": {
            "verb": "pelt"
        }
    },
    {
        "start": 360,
        "end": 360,
        "entry": {
            "verb": "penalize"
        }
    },
    {
        "start": 361,
        "end": 361,
        "entry": {
            "verb": "perform"
        }
    },
    {
        "start": 362,
        "end": 362,
        "entry": {
            "verb": "persecute"
        }
    },
    {
        "start": 363,
        "end": 363,
        "entry": {
            "verb": "persuade"
        }
    },
    {
        "start": 364,
        "end": 364,
        "entry": {
            "verb": "petition"
        }
    },
    {
        "start": 365,
        "end": 365,
        "entry": {
            "verb": "play"
        }
    },
    {
        "start": 366,
        "end": 366,
        "entry": {
            "verb": "plead"
        }
    },
    {
        "start": 367,
        "end": 367,
        "entry": {
            "verb": "plunder"
        }
    },
    {
        "start": 368,
        "end": 368,
        "entry": {
            "verb": "pollute"
        }
    },
    {
        "start": 369,
        "end": 369,
        "entry": {
            "verb": "pounce"
        }
    },
    {
        "start": 370,
        "end": 370,
        "entry": {
            "verb": "practice"
        }
    },
    {
        "start": 371,
        "end": 371,
        "entry": {
            "verb": "praise"
        }
    },
    {
        "start": 372,
        "end": 372,
        "entry": {
            "verb": "preach"
        }
    },
    {
        "start": 373,
        "end": 373,
        "entry": {
            "verb": "proclaim"
        }
    },
    {
        "start": 374,
        "end": 374,
        "entry": {
            "verb": "prohibit"
        }
    },
    {
        "start": 375,
        "end": 375,
        "entry": {
            "verb": "promote"
        }
    },
    {
        "start": 376,
        "end": 376,
        "entry": {
            "verb": "pronounce"
        }
    },
    {
        "start": 377,
        "end": 377,
        "entry": {
            "verb": "prophesize"
        }
    },
    {
        "start": 378,
        "end": 378,
        "entry": {
            "verb": "prosecute"
        }
    },
    {
        "start": 379,
        "end": 379,
        "entry": {
            "verb": "protect"
        }
    },
    {
        "start": 380,
        "end": 380,
        "entry": {
            "verb": "protest"
        }
    },
    {
        "start": 381,
        "end": 381,
        "entry": {
            "verb": "provide"
        }
    },
    {
        "start": 382,
        "end": 382,
        "entry": {
            "verb": "provoke"
        }
    },
    {
        "start": 383,
        "end": 383,
        "entry": {
            "verb": "prowl"
        }
    },
    {
        "start": 384,
        "end": 384,
        "entry": {
            "verb": "pry"
        }
    },
    {
        "start": 385,
        "end": 385,
        "entry": {
            "verb": "punch"
        }
    },
    {
        "start": 386,
        "end": 386,
        "entry": {
            "verb": "punish"
        }
    },
    {
        "start": 387,
        "end": 387,
        "entry": {
            "verb": "purchase"
        }
    },
    {
        "start": 388,
        "end": 388,
        "entry": {
            "verb": "pursue"
        }
    },
    {
        "start": 389,
        "end": 389,
        "entry": {
            "verb": "push"
        }
    },
    {
        "start": 390,
        "end": 390,
        "entry": {
            "verb": "quarrel"
        }
    },
    {
        "start": 391,
        "end": 391,
        "entry": {
            "verb": "query"
        }
    },
    {
        "start": 392,
        "end": 392,
        "entry": {
            "verb": "queue"
        }
    },
    {
        "start": 393,
        "end": 393,
        "entry": {
            "verb": "rage"
        }
    },
    {
        "start": 394,
        "end": 394,
        "entry": {
            "verb": "raid"
        }
    },
    {
        "start": 395,
        "end": 395,
        "entry": {
            "verb": "ransack"
        }
    },
    {
        "start": 396,
        "end": 396,
        "entry": {
            "verb": "rebel"
        }
    },
    {
        "start": 397,
        "end": 397,
        "entry": {
            "verb": "recite"
        }
    },
    {
        "start": 398,
        "end": 398,
        "entry": {
            "verb": "recount"
        }
    },
    {
        "start": 399,
        "end": 399,
        "entry": {
            "verb": "recruit"
        }
    },
    {
        "start": 400,
        "end": 400,
        "entry": {
            "verb": "rejoice"
        }
    },
    {
        "start": 401,
        "end": 401,
        "entry": {
            "verb": "remark"
        }
    },
    {
        "start": 402,
        "end": 402,
        "entry": {
            "verb": "renege"
        }
    },
    {
        "start": 403,
        "end": 403,
        "entry": {
            "verb": "repair"
        }
    },
    {
        "start": 404,
        "end": 404,
        "entry": {
            "verb": "research"
        }
    },
    {
        "start": 405,
        "end": 405,
        "entry": {
            "verb": "rescue"
        }
    },
    {
        "start": 406,
        "end": 406,
        "entry": {
            "verb": "resist"
        }
    },
    {
        "start": 407,
        "end": 407,
        "entry": {
            "verb": "restrain"
        }
    },
    {
        "start": 408,
        "end": 408,
        "entry": {
            "verb": "resurrect"
        }
    },
    {
        "start": 409,
        "end": 409,
        "entry": {
            "verb": "reveal"
        }
    },
    {
        "start": 410,
        "end": 410,
        "entry": {
            "verb": "revolt"
        }
    },
    {
        "start": 411,
        "end": 411,
        "entry": {
            "verb": "reward"
        }
    },
    {
        "start": 412,
        "end": 412,
        "entry": {
            "verb": "ridicule"
        }
    },
    {
        "start": 413,
        "end": 413,
        "entry": {
            "verb": "riot"
        }
    },
    {
        "start": 414,
        "end": 414,
        "entry": {
            "verb": "rob"
        }
    },
    {
        "start": 415,
        "end": 415,
        "entry": {
            "verb": "run"
        }
    },
    {
        "start": 416,
        "end": 416,
        "entry": {
            "verb": "rush"
        }
    },
    {
        "start": 417,
        "end": 417,
        "entry": {
            "verb": "salute"
        }
    },
    {
        "start": 418,
        "end": 418,
        "entry": {
            "verb": "scamper"
        }
    },
    {
        "start": 419,
        "end": 419,
        "entry": {
            "verb": "scare"
        }
    },
    {
        "start": 420,
        "end": 420,
        "entry": {
            "verb": "scavenge"
        }
    },
    {
        "start": 421,
        "end": 421,
        "entry": {
            "verb": "scream"
        }
    },
    {
        "start": 422,
        "end": 422,
        "entry": {
            "verb": "scrounge"
        }
    },
    {
        "start": 423,
        "end": 423,
        "entry": {
            "verb": "search"
        }
    },
    {
        "start": 424,
        "end": 424,
        "entry": {
            "verb": "secure"
        }
    },
    {
        "start": 425,
        "end": 425,
        "entry": {
            "verb": "seduce"
        }
    },
    {
        "start": 426,
        "end": 426,
        "entry": {
            "verb": "segregate"
        }
    },
    {
        "start": 427,
        "end": 427,
        "entry": {
            "verb": "seize"
        }
    },
    {
        "start": 428,
        "end": 428,
        "entry": {
            "verb": "sell"
        }
    },
    {
        "start": 429,
        "end": 429,
        "entry": {
            "verb": "ship"
        }
    },
    {
        "start": 430,
        "end": 430,
        "entry": {
            "verb": "shout"
        }
    },
    {
        "start": 431,
        "end": 431,
        "entry": {
            "verb": "shove"
        }
    },
    {
        "start": 432,
        "end": 432,
        "entry": {
            "verb": "show"
        }
    },
    {
        "start": 433,
        "end": 433,
        "entry": {
            "verb": "silence"
        }
    },
    {
        "start": 434,
        "end": 434,
        "entry": {
            "verb": "sing"
        }
    },
    {
        "start": 435,
        "end": 435,
        "entry": {
            "verb": "slaughter"
        }
    },
    {
        "start": 436,
        "end": 436,
        "entry": {
            "verb": "sleep"
        }
    },
    {
        "start": 437,
        "end": 437,
        "entry": {
            "verb": "smash"
        }
    },
    {
        "start": 438,
        "end": 438,
        "entry": {
            "verb": "sob"
        }
    },
    {
        "start": 439,
        "end": 439,
        "entry": {
            "verb": "solicit"
        }
    },
    {
        "start": 440,
        "end": 440,
        "entry": {
            "verb": "speak"
        }
    },
    {
        "start": 441,
        "end": 441,
        "entry": {
            "verb": "spill"
        }
    },
    {
        "start": 442,
        "end": 442,
        "entry": {
            "verb": "spit"
        }
    },
    {
        "start": 443,
        "end": 443,
        "entry": {
            "verb": "spy"
        }
    },
    {
        "start": 444,
        "end": 444,
        "entry": {
            "verb": "stab"
        }
    },
    {
        "start": 445,
        "end": 445,
        "entry": {
            "verb": "stage"
        }
    },
    {
        "start": 446,
        "end": 446,
        "entry": {
            "verb": "startle"
        }
    },
    {
        "start": 447,
        "end": 447,
        "entry": {
            "verb": "steal"
        }
    },
    {
        "start": 448,
        "end": 448,
        "entry": {
            "verb": "stop"
        }
    },
    {
        "start": 449,
        "end": 449,
        "entry": {
            "verb": "strangle"
        }
    },
    {
        "start": 450,
        "end": 450,
        "entry": {
            "verb": "strike"
        }
    },
    {
        "start": 451,
        "end": 451,
        "entry": {
            "verb": "subdue"
        }
    },
    {
        "start": 452,
        "end": 452,
        "entry": {
            "verb": "suffer"
        }
    },
    {
        "start": 453,
        "end": 453,
        "entry": {
            "verb": "summon"
        }
    },
    {
        "start": 454,
        "end": 454,
        "entry": {
            "verb": "surround"
        }
    },
    {
        "start": 455,
        "end": 455,
        "entry": {
            "verb": "suspect"
        }
    },
    {
        "start": 456,
        "end": 456,
        "entry": {
            "verb": "take"
        }
    },
    {
        "start": 457,
        "end": 457,
        "entry": {
            "verb": "taunt"
        }
    },
    {
        "start": 458,
        "end": 458,
        "entry": {
            "verb": "tease"
        }
    },
    {
        "start": 459,
        "end": 459,
        "entry": {
            "verb": "tempt"
        }
    },
    {
        "start": 460,
        "end": 460,
        "entry": {
            "verb": "terrify"
        }
    },
    {
        "start": 461,
        "end": 461,
        "entry": {
            "verb": "terrorize"
        }
    },
    {
        "start": 462,
        "end": 462,
        "entry": {
            "verb": "thank"
        }
    },
    {
        "start": 463,
        "end": 463,
        "entry": {
            "verb": "threaten"
        }
    },
    {
        "start": 464,
        "end": 464,
        "entry": {
            "verb": "throw"
        }
    },
    {
        "start": 465,
        "end": 465,
        "entry": {
            "verb": "torment"
        }
    },
    {
        "start": 466,
        "end": 466,
        "entry": {
            "verb": "torture"
        }
    },
    {
        "start": 467,
        "end": 467,
        "entry": {
            "verb": "trade"
        }
    },
    {
        "start": 468,
        "end": 468,
        "entry": {
            "verb": "transform"
        }
    },
    {
        "start": 469,
        "end": 469,
        "entry": {
            "verb": "translate"
        }
    },
    {
        "start": 470,
        "end": 470,
        "entry": {
            "verb": "transport"
        }
    },
    {
        "start": 471,
        "end": 471,
        "entry": {
            "verb": "trap"
        }
    },
    {
        "start": 472,
        "end": 472,
        "entry": {
            "verb": "travel"
        }
    },
    {
        "start": 473,
        "end": 473,
        "entry": {
            "verb": "tug"
        }
    },
    {
        "start": 474,
        "end": 474,
        "entry": {
            "verb": "unite"
        }
    },
    {
        "start": 475,
        "end": 475,
        "entry": {
            "verb": "unleash"
        }
    },
    {
        "start": 476,
        "end": 476,
        "entry": {
            "verb": "unload"
        }
    },
    {
        "start": 477,
        "end": 477,
        "entry": {
            "verb": "unveil"
        }
    },
    {
        "start": 478,
        "end": 478,
        "entry": {
            "verb": "vandalize"
        }
    },
    {
        "start": 479,
        "end": 479,
        "entry": {
            "verb": "vanish"
        }
    },
    {
        "start": 480,
        "end": 480,
        "entry": {
            "verb": "victimize"
        }
    },
    {
        "start": 481,
        "end": 481,
        "entry": {
            "verb": "violate"
        }
    },
    {
        "start": 482,
        "end": 482,
        "entry": {
            "verb": "volunteer"
        }
    },
    {
        "start": 483,
        "end": 483,
        "entry": {
            "verb": "wait"
        }
    },
    {
        "start": 484,
        "end": 484,
        "entry": {
            "verb": "warn"
        }
    },
    {
        "start": 485,
        "end": 485,
        "entry": {
            "verb": "wave"
        }
    },
    {
        "start": 486,
        "end": 486,
        "entry": {
            "verb": "weep"
        }
    },
    {
        "start": 487,
        "end": 487,
        "entry": {
            "verb": "welcome"
        }
    },
    {
        "start": 488,
        "end": 488,
        "entry": {
            "verb": "whittle"
        }
    },
    {
        "start": 489,
        "end": 489,
        "entry": {
            "verb": "wield"
        }
    },
    {
        "start": 490,
        "end": 490,
        "entry": {
            "verb": "win"
        }
    },
    {
        "start": 491,
        "end": 491,
        "entry": {
            "verb": "wink"
        }
    },
    {
        "start": 492,
        "end": 492,
        "entry": {
            "verb": "witness"
        }
    },
    {
        "start": 493,
        "end": 493,
        "entry": {
            "verb": "worship"
        }
    },
    {
        "start": 494,
        "end": 494,
        "entry": {
            "verb": "wound"
        }
    },
    {
        "start": 495,
        "end": 495,
        "entry": {
            "verb": "wreck"
        }
    },
    {
        "start": 496,
        "end": 496,
        "entry": {
            "verb": "wrestle"
        }
    },
    {
        "start": 497,
        "end": 497,
        "entry": {
            "verb": "write"
        }
    },
    {
        "start": 498,
        "end": 498,
        "entry": {
            "verb": "yell"
        }
    },
    {
        "start": 499,
        "end": 499,
        "entry": {
            "verb": "yield"
        }
    }
];


(0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("elm"),
    flags: {
        generatorData: {
            itemRelicName: $336b61757523412a$export$75315e8f908e65f1,
            urbanEvent: $56539e93f2f464a7$export$e20f46e0e4569dbd,
            wildernessEvent: $56539e93f2f464a7$export$fe81d40a8678853c,
            quest: $37d9c5575de5defb$export$cbc1416578dd3747,
            questSource: $37d9c5575de5defb$export$74fe797f33b01eca,
            verb: $c8c09cedc3d42941$export$eaf9d4c12671ce55
        }
    }
});


//# sourceMappingURL=index.e104626f.js.map
